import React, { useState, useEffect, useRef } from "react";
import Highcharts from "highcharts";
import BoxWrapper from "../../../../components/ui/boxWrapper";
import axios from "../../../../axios-order";
import { ToastContainer } from 'react-toastify';
import VisibilityIcon from "@mui/icons-material/Visibility";
import { useHistory, useParams, useLocation } from 'react-router-dom';
import {
    MenuItem, Select, Dialog, DialogTitle,
    DialogContent, DialogActions,
} from "@mui/material";
import { ValidatorForm } from "react-material-ui-form-validator";
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import CheckIcon from '@mui/icons-material/Check';
import ClearIcon from '@mui/icons-material/Clear';
import HourglassBottomIcon from '@mui/icons-material/HourglassBottom';
import WarningIcon from '@mui/icons-material/Warning';
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import moment from 'moment';
import Tooltip from "@mui/material/Tooltip";
import excelIconImage from '../../../../asserts/images/excelicon.svg';
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import AddCircleIcon from '@mui/icons-material/AddCircle';
import Inputfield from "../../../../components/ui/inputField";

import {
    Modal,
    Box,
    Typography,
    Button,
    CircularProgress,
    Checkbox,
    ListItemText,
    TablePagination,
    Snackbar, Alert
} from "@mui/material";
import {
    DataGridPro,
    GridToolbarColumnsButton,
    GridToolbarFilterButton,
    GridToolbarDensitySelector,
} from '@mui/x-data-grid-pro';

// DashboardCard Component (unchanged)

const LogTable = ({ recordForLogTable, loaderForTable, getApiLogReport, handleViewData, onClickExport }) => {
    return (
        <BoxWrapper
            boxTitle="IMS Reconciliation"
            addButtonLabel="Refresh"
            enableAddButton={true}
            // addButtonLabel="Refresh"
            addButtonHandlerFn={getApiLogReport}
        >
            <div style={{
                maxHeight: "400px", // Set max height for vertical scrolling
                overflowY: "auto", // Enable vertical scrolling
                overflowX: "auto", // Enable horizontal scrolling
                width: "100%", // Ensure the div takes full width
            }} >
                <table className="custome-table">
                    <thead>
                        <tr>
                            <th>Recon Datetime</th>
                            <th>Created Date</th>
                            <th>Status</th>
                            <th>Action</th>

                        </tr>
                    </thead>
                    <tbody>
                        {recordForLogTable?.map((v, index) => {
                            // Determine if the icon should be disabled
                            const isDisabled =
                                v.status?.toLowerCase() === "initiated" ||
                                v.status?.toLowerCase() === "in progress" ||
                                v.status?.toLowerCase() === "failed";

                            return (
                                <tr key={v.id}>
                                    <td>{v.recon_datetime}</td>
                                    <td>{v.created_date}</td>
                                    <td>{v.status}</td>
                                    <td>
                                        <VisibilityOutlinedIcon
                                            sx={{
                                                color: isDisabled ? "gray" : "#64adf7", // Gray when disabled, blue when enabled
                                                cursor: isDisabled ? "not-allowed" : "pointer", // Change cursor style
                                                opacity: isDisabled ? 0.5 : 1, // Reduce opacity for disabled state
                                            }}
                                            onClick={
                                                isDisabled
                                                    ? () => { } // No action if disabled
                                                    : () => handleViewData(v.ims_recon_id, v.tax_period) // Enable click action if status is "Passed"
                                            }
                                        />

                                        {
                                            (v.status === "Pass") ? (
                                                v.is_valid !== "N" ?
                                                    (
                                                        (!v.excel_loading ?
                                                            <img
                                                                onClick={isDisabled ? () => { } : () => onClickExport(v.ims_recon_id)}
                                                                style={{
                                                                    marginLeft: '5px',
                                                                    height: '23px',
                                                                    width: '25px',
                                                                    cursor: isDisabled ? 'not-allowed' : 'pointer',
                                                                    opacity: isDisabled ? 0.5 : 1,
                                                                    filter: isDisabled ? 'grayscale(100%)' : 'none'
                                                                }}
                                                                src={excelIconImage}
                                                            />
                                                            : <>
                                                                <CircularProgress
                                                                    size={20}
                                                                    style={{ color: "green", marginLeft: '5px', marginTop: '2px' }}
                                                                />
                                                            </>)
                                                    )
                                                    :
                                                    (
                                                        <Tooltip title="Recon is Invalid">
                                                            <img
                                                                style={{
                                                                    marginLeft: '5px',
                                                                    height: '23px',
                                                                    width: '25px',
                                                                    opacity: isDisabled ? 0.5 : 1,
                                                                    filter: isDisabled ? 'grayscale(100%)' : 'none',
                                                                    cursor: isDisabled ? 'not-allowed' : 'default'
                                                                }}
                                                                src={excelIconImage}
                                                            />
                                                        </Tooltip>
                                                    )
                                            ) : (
                                                <img
                                                    style={{
                                                        marginLeft: '5px',
                                                        height: '23px',
                                                        width: '25px',
                                                        cursor: isDisabled ? 'not-allowed' : 'pointer',
                                                        opacity: isDisabled ? 0.5 : 1,
                                                        filter: isDisabled ? 'grayscale(100%)' : 'none'
                                                    }}
                                                    src={excelIconImage}
                                                    onClick={isDisabled ? () => { } : () => onClickExport(v.ims_recon_id)}
                                                />
                                            )
                                        }
                                    </td>
                                </tr>
                            );
                        })}
                        {loaderForTable ? (
                            <tr>
                                <td
                                    colSpan={4}
                                    style={{
                                        color: "black",
                                        textAlign: "center",
                                        fontWeight: "bold",
                                    }}
                                >
                                    Loading…Please wait
                                </td>
                            </tr>
                        ) : recordForLogTable?.length === 0 ? (
                            <tr>
                                <td colSpan={4} style={{ color: "red", textAlign: "center" }}>
                                    No Data Found!
                                </td>
                            </tr>
                        ) : null}
                    </tbody>
                    {/* <tbody>
                        {recordForLogTable?.map((v, index) => {
                            // Determine if the icon should be disabled
                            const isDisabled =
                                v.status?.toLowerCase() === "initiated" ||
                                v.status?.toLowerCase() === "in progress" ||
                                v.status?.toLowerCase() === "failed";

                            return (
                                <tr key={v.id}>
                                    <td>{v.recon_datetime}</td>
                                    <td>{v.created_date}</td>
                                    <td>{v.status}</td>
                                    <td>
                                        <VisibilityOutlinedIcon
                                            sx={{
                                                color: isDisabled ? "gray" : "#64adf7", // Gray when disabled, blue when enabled
                                                cursor: isDisabled ? "not-allowed" : "pointer", // Change cursor style
                                                opacity: isDisabled ? 0.5 : 1, // Reduce opacity for disabled state
                                            }}
                                            onClick={
                                                isDisabled
                                                    ? () => { } // No action if disabled
                                                    : () => handleViewData(v.ims_recon_id, v.tax_period) // Enable click action if status is "Passed"
                                            }
                                        />

                                        {
                                            (v.status === "Pass") ? (
                                                v.is_valid !== "N" ?

                                                    (
                                                        (!v.excel_loading ? <img onClick={() => onClickExport(v.ims_recon_id)} style={{ marginLeft: '5px', height: '23px', width: '25px', cursor: 'pointer' }} src={excelIconImage} />
                                                            : <>
                                                                <CircularProgress
                                                                    size={20}
                                                                    style={{ color: "green", marginLeft: '5px', marginTop: '2px' }}
                                                                />
                                                            </>)
                                                    )


                                                    :

                                                    (
                                                        <Tooltip title="Recon is Invalid">
                                                            <img style={{ marginLeft: '5px', height: '23px', width: '25px' }} src={excelIconImage} />
                                                        </Tooltip>
                                                    )
                                            ) : (



                                                <img style={{ marginLeft: '5px', height: '23px', width: '25px', cursor: 'pointer' }} src={excelIconImage} />

                                            )
                                        }
                                    </td>
                                </tr>
                            );
                        })}
                        {loaderForTable ? (
                            <tr>
                                <td
                                    colSpan={4}
                                    style={{
                                        color: "black",
                                        textAlign: "center",
                                        fontWeight: "bold",
                                    }}
                                >
                                    Loading…Please wait
                                </td>
                            </tr>
                        ) : recordForLogTable?.length === 0 ? (
                            <tr>
                                <td colSpan={4} style={{ color: "red", textAlign: "center" }}>
                                    No Data Found!
                                </td>
                            </tr>
                        ) : null}
                    </tbody> */}
                </table>
            </div>
        </BoxWrapper>
    );
};


const DashboardCard = ({ title, value, icon, iconColor }) => {
    return (
        <Card
            sx={{
                boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
                borderRadius: 4,
                padding: 3,
                position: 'relative',
                background: 'linear-gradient(135deg, #eef2ff 0%, #6d7590ff 100%)',
                border: '2px solid transparent',
                backgroundClip: 'padding-box',
                borderImage: 'linear-gradient(135deg, YOUR_GRADIENT_HERE) 1',
                transition: 'all 0.3s ease',
                '&:hover': {
                    transform: 'scale(1.05)',
                    boxShadow: '0 10px 35px rgba(0, 0, 0, 0.15)',
                },
            }}
        >
            <Box
                sx={{
                    position: 'absolute',
                    top: 15,
                    right: 15,
                    backgroundColor: iconColor,
                    width: 42,
                    height: 42,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    borderRadius: '50%',
                    boxShadow: '0 4px 10px rgba(0,0,0,0.1)',
                }}
            >
                {icon}
            </Box>
            <Typography
                variant="h7"
                sx={{
                    fontWeight: 600,
                    color: '#1e293b',
                    textTransform: 'capitalize',
                    fontFamily: "'Poppins', sans-serif",
                }}
            >
                {title}
            </Typography>
            <Typography variant="h6" sx={{ marginTop: 1, fontWeight: 700 }}>
                {value}
            </Typography>
        </Card>
    );
};
const CircularMetricCard = ({ status, count, totalValue, totalIGST, totalCGST, totalSGST, maxCount = 10 }) => {
    const percentage = maxCount > 0 ? Math.min((count / maxCount) * 100, 100) : 0;
    const circumference = 2 * Math.PI * 58;
    const strokeDashoffset = circumference - (percentage / 100) * circumference;

    return (
        <Card
            sx={{
                height: '420px', // Fixed height for all cards
                display: 'flex',
                flexDirection: 'column',
                boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
                borderRadius: 3,
                transition: 'all 0.3s ease',
                '&:hover': {
                    transform: 'translateY(-4px)',
                    boxShadow: '0 8px 30px rgba(0, 0, 0, 0.12)',
                },
            }}
        >
            <Box sx={{ p: 3, flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
                {/* Header */}
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                    <Typography variant="subtitle1" sx={{ fontWeight: 600, color: '#475569' }}>
                        {status}
                    </Typography>
                </Box>

                {/* Circular Progress */}
                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', my: 2 }}>
                    <Box sx={{ position: 'relative', display: 'inline-flex' }}>
                        <svg style={{ transform: 'rotate(-90deg)' }} width="140" height="140">
                            {/* Background Circle */}
                            <circle
                                cx="70"
                                cy="70"
                                r="58"
                                stroke="#f1f5f9"
                                strokeWidth="12"
                                fill="none"
                            />

                            {/* Gradient Definition */}
                            <defs>
                                <linearGradient id={`gradient-${status}`} x1="0%" y1="0%" x2="100%" y2="100%">
                                    <stop offset="0%" stopColor={status === "Accepted" ? "#10b981" :
                                        status === "Rejected" ? "#ef4444" :
                                            status === "Pending" ? "#f59e0b" : "#8b5cf6"} />
                                    <stop offset="100%" stopColor={status === "Accepted" ? "#059669" :
                                        status === "Rejected" ? "#dc2626" :
                                            status === "Pending" ? "#d97706" : "#7c3aed"} />
                                </linearGradient>
                            </defs>

                            {/* Progress Circle */}
                            <circle
                                cx="70"
                                cy="70"
                                r="58"
                                stroke={`url(#gradient-${status})`}
                                strokeWidth="12"
                                fill="none"
                                strokeDasharray={circumference}
                                strokeDashoffset={strokeDashoffset}
                                strokeLinecap="round"
                                style={{ transition: 'stroke-dashoffset 0.5s ease' }}
                            />
                        </svg>

                        {/* Center Content */}
                        <Box
                            sx={{
                                position: 'absolute',
                                top: 0,
                                left: 0,
                                right: 0,
                                bottom: 0,
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                justifyContent: 'center',
                            }}
                        >
                            <Typography variant="h4" sx={{ fontWeight: 700, color: '#1e293b' }}>
                                {count.toLocaleString()}
                            </Typography>
                            <Typography variant="caption" sx={{ color: '#64748b', fontSize: '0.75rem', mt: 0.5 }}>
                                invoices
                            </Typography>
                        </Box>
                    </Box>
                </Box>

                {/* Value Display */}
                <Box sx={{ textAlign: 'center', mb: 2 }}>
                    <Typography variant="caption" sx={{ color: '#64748b', fontSize: '0.85rem' }}>
                        Total Value
                    </Typography>
                    <Typography variant="h6" sx={{ fontWeight: 700, color: '#1e293b', mt: 0.5 }}>
                        ₹{totalValue.toLocaleString('en-IN', { maximumFractionDigits: 2 })}
                    </Typography>
                </Box>

                {/* Tax Details with Color-coded Indicators */}
                {/* {(totalIGST > 0 || totalCGST > 0 || totalSGST > 0) && ( */}
                <Box
                    sx={{
                        mt: 'auto',
                        pt: 2,
                        borderTop: '1px solid #e2e8f0',
                    }}
                >
                    <Grid container spacing={1.5}>
                        {/* IGST - Purple/Blue */}
                        <Grid item xs={4}>
                            <Box
                                sx={{
                                    textAlign: 'center',
                                    p: 1.5,
                                    borderRadius: 2,
                                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                                    position: 'relative',
                                    overflow: 'hidden',
                                    '&::before': {
                                        content: '""',
                                        position: 'absolute',
                                        top: 0,
                                        left: 0,
                                        right: 0,
                                        bottom: 0,
                                        background: 'rgba(255, 255, 255, 0.1)',
                                        backdropFilter: 'blur(10px)',
                                    }
                                }}
                            >
                                <Typography
                                    variant="caption"
                                    sx={{
                                        color: '#fff',
                                        fontWeight: 600,
                                        fontSize: '0.7rem',
                                        position: 'relative',
                                        zIndex: 1
                                    }}
                                >
                                    IGST
                                </Typography>
                                <Typography
                                    variant="body2"
                                    sx={{
                                        color: '#fff',
                                        fontWeight: 700,
                                        fontSize: '0.85rem',
                                        mt: 0.5,
                                        position: 'relative',
                                        zIndex: 1
                                    }}
                                >
                                    ₹{totalIGST.toLocaleString('en-IN')}
                                </Typography>
                            </Box>
                        </Grid>

                        {/* CGST - Orange/Red */}
                        <Grid item xs={4}>
                            <Box
                                sx={{
                                    textAlign: 'center',
                                    p: 1.5,
                                    borderRadius: 2,
                                    background: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
                                    position: 'relative',
                                    overflow: 'hidden',
                                    '&::before': {
                                        content: '""',
                                        position: 'absolute',
                                        top: 0,
                                        left: 0,
                                        right: 0,
                                        bottom: 0,
                                        background: 'rgba(255, 255, 255, 0.1)',
                                        backdropFilter: 'blur(10px)',
                                    }
                                }}
                            >
                                <Typography
                                    variant="caption"
                                    sx={{
                                        color: '#fff',
                                        fontWeight: 600,
                                        fontSize: '0.7rem',
                                        position: 'relative',
                                        zIndex: 1
                                    }}
                                >
                                    CGST
                                </Typography>
                                <Typography
                                    variant="body2"
                                    sx={{
                                        color: '#fff',
                                        fontWeight: 700,
                                        fontSize: '0.85rem',
                                        mt: 0.5,
                                        position: 'relative',
                                        zIndex: 1
                                    }}
                                >
                                    ₹{totalCGST.toLocaleString('en-IN')}
                                </Typography>
                            </Box>
                        </Grid>

                        {/* SGST - Orange/Yellow */}
                        <Grid item xs={4}>
                            <Box
                                sx={{
                                    textAlign: 'center',
                                    p: 1.5,
                                    borderRadius: 2,
                                    background: 'linear-gradient(135deg, #ffecd2 0%, #fcb69f 100%)',
                                    position: 'relative',
                                    overflow: 'hidden',
                                    '&::before': {
                                        content: '""',
                                        position: 'absolute',
                                        top: 0,
                                        left: 0,
                                        right: 0,
                                        bottom: 0,
                                        background: 'rgba(255, 255, 255, 0.2)',
                                        backdropFilter: 'blur(10px)',
                                    }
                                }}
                            >
                                <Typography
                                    variant="caption"
                                    sx={{
                                        color: '#b45309',
                                        fontWeight: 600,
                                        fontSize: '0.7rem',
                                        position: 'relative',
                                        zIndex: 1
                                    }}
                                >
                                    SGST
                                </Typography>
                                <Typography
                                    variant="body2"
                                    sx={{
                                        color: '#92400e',
                                        fontWeight: 700,
                                        fontSize: '0.85rem',
                                        mt: 0.5,
                                        position: 'relative',
                                        zIndex: 1
                                    }}
                                >
                                    ₹{totalSGST.toLocaleString('en-IN')}
                                </Typography>
                            </Box>
                        </Grid>
                    </Grid>
                </Box>
                {/* )} */}
            </Box>
        </Card>
    );
};



const columns = [
    {
        field: 'record_type',
        headerName: 'Record Type',
        flex: 1,
        minWidth: 150,
        align: 'center',
        headerAlign: 'center',
        filterable: true,
    },
    {
        field: 'trade_legal_name',
        headerName: 'Legal Name',
        flex: 1,
        minWidth: 150,
        align: 'center',
        headerAlign: 'center',
        filterable: true,
    },
    {
        field: 'recipient_gstin',
        headerName: 'GSTIN',
        flex: 1,
        minWidth: 200,
        align: 'center',
        headerAlign: 'center',
        filterable: true,
    },
    {
        field: 'invoice_number',
        headerName: 'Invoice Number',
        flex: 1,
        minWidth: 180,
        align: 'center',
        headerAlign: 'center',
        filterable: true,
    },
    {
        field: 'invoice_date',
        headerName: 'Invoice Date',
        flex: 1,
        minWidth: 180,
        align: 'center',
        headerAlign: 'center',
        filterable: true,
    },
    // {
    //     field: 'reported_in_form',
    //     headerName: 'Reported in Form',
    //     flex: 1,
    //     minWidth: 180,
    //     align: 'center',
    //     headerAlign: 'center',
    //     filterable: true,
    // },
    {
        field: 'total_invoice_value',
        headerName: 'Total Invoice Value',
        flex: 1,
        minWidth: 180,
        align: 'center',
        headerAlign: 'center',
        filterable: true,
    },
    {
        field: 'total_taxable_value',
        headerName: 'Total Taxable Value',
        flex: 1,
        minWidth: 180,
        align: 'center',
        headerAlign: 'center',
        filterable: true,
    },
    {
        field: 'integrated_tax',
        headerName: 'Integrated Tax',
        flex: 1,
        minWidth: 180,
        align: 'center',
        headerAlign: 'center',
        filterable: true,
    },
    {
        field: 'central_tax',
        headerName: 'Central Tax',
        flex: 1,
        minWidth: 180,
        align: 'center',
        headerAlign: 'center',
        filterable: true,
    },
    {
        field: 'state_ut_tax',
        headerName: 'State Tax',
        flex: 1,
        minWidth: 180,
        align: 'center',
        headerAlign: 'center',
        filterable: true,
    },
    {
        field: 'return_period',
        headerName: 'Return Period',
        flex: 1,
        minWidth: 180,
        align: 'center',
        headerAlign: 'center',
        filterable: true,
    },
    {
        field: 'status',
        headerName: 'Status',
        flex: 1,
        minWidth: 180,
        align: 'center',
        headerAlign: 'center',
        filterable: true,

    },
    {
        field: 'remarks_by_recipient',
        headerName: 'Remarks by Recipient',
        flex: 1,
        minWidth: 180,
        align: 'center',
        headerAlign: 'center',
        filterable: true,

    },
    {
        field: 'gstr1_recon_status',
        headerName: 'GSTR 1 Recon Status',
        flex: 1,
        minWidth: 180,
        align: 'center',
        headerAlign: 'center',
        filterable: true,
    },
];


const acceptColumns = [
    {
        field: 'record_type',
        headerName: 'Record Type',
        flex: 1,
        minWidth: 150,
        align: 'center',
        headerAlign: 'center',
        filterable: true,
    },
    {
        field: 'trade_legal_name',
        headerName: 'Legal Name',
        flex: 1,
        minWidth: 150,
        align: 'center',
        headerAlign: 'center',
        filterable: true,
    },
    {
        field: 'recipient_gstin',
        headerName: 'GSTIN',
        flex: 1,
        minWidth: 200,
        align: 'center',
        headerAlign: 'center',
        filterable: true,
    },
    {
        field: 'invoice_number',
        headerName: 'Invoice Number',
        flex: 1,
        minWidth: 180,
        align: 'center',
        headerAlign: 'center',
        filterable: true,
    },
    {
        field: 'invoice_date',
        headerName: 'Invoice Date',
        flex: 1,
        minWidth: 180,
        align: 'center',
        headerAlign: 'center',
        filterable: true,
    },
    // {
    //     field: 'reported_in_form',
    //     headerName: 'Reported in Form',
    //     flex: 1,
    //     minWidth: 180,
    //     align: 'center',
    //     headerAlign: 'center',
    //     filterable: true,
    // },
    {
        field: 'total_invoice_value',
        headerName: 'Total Invoice Value',
        flex: 1,
        minWidth: 180,
        align: 'center',
        headerAlign: 'center',
        filterable: true,
    },
    {
        field: 'total_taxable_value',
        headerName: 'Total Taxable Value',
        flex: 1,
        minWidth: 180,
        align: 'center',
        headerAlign: 'center',
        filterable: true,
    },
    {
        field: 'integrated_tax',
        headerName: 'Integrated Tax',
        flex: 1,
        minWidth: 180,
        align: 'center',
        headerAlign: 'center',
        filterable: true,
    },
    {
        field: 'central_tax',
        headerName: 'Central Tax',
        flex: 1,
        minWidth: 180,
        align: 'center',
        headerAlign: 'center',
        filterable: true,
    },
    {
        field: 'state_ut_tax',
        headerName: 'State Tax',
        flex: 1,
        minWidth: 180,
        align: 'center',
        headerAlign: 'center',
        filterable: true,
    },
    {
        field: 'return_period',
        headerName: 'Return Period',
        flex: 1,
        minWidth: 180,
        align: 'center',
        headerAlign: 'center',
        filterable: true,
    },
    {
        field: 'status',
        headerName: 'Status',
        flex: 1,
        minWidth: 180,
        align: 'center',
        headerAlign: 'center',
        filterable: true,

    },
    {
        field: 'remarks_by_recipient',
        headerName: 'Remarks by Recipient',
        flex: 1,
        minWidth: 180,
        align: 'center',
        headerAlign: 'center',
        filterable: true,

    },
    {
        field: 'gstr1_recon_status',
        headerName: 'GSTR 1 Recon Status',
        flex: 1,
        minWidth: 180,
        align: 'center',
        headerAlign: 'center',
        filterable: true,
    },

];

const rejectColumns = [
    {
        field: 'record_type',
        headerName: 'Record Typea',
        flex: 1,
        minWidth: 150,
        align: 'center',
        headerAlign: 'center',
        filterable: true,
    },
    {
        field: 'trade_legal_name',
        headerName: 'Legal Name',
        flex: 1,
        minWidth: 150,
        align: 'center',
        headerAlign: 'center',
        filterable: true,
    },
    {
        field: 'recipient_gstin',
        headerName: 'GSTIN',
        flex: 1,
        minWidth: 200,
        align: 'center',
        headerAlign: 'center',
        filterable: true,
    },
    {
        field: 'invoice_number',
        headerName: 'Invoice Number',
        flex: 1,
        minWidth: 180,
        align: 'center',
        headerAlign: 'center',
        filterable: true,
    },
    {
        field: 'invoice_date',
        headerName: 'Invoice Date',
        flex: 1,
        minWidth: 180,
        align: 'center',
        headerAlign: 'center',
        filterable: true,
    },
    // {
    //     field: 'reported_in_form',
    //     headerName: 'Reported in Form',
    //     flex: 1,
    //     minWidth: 180,
    //     align: 'center',
    //     headerAlign: 'center',
    //     filterable: true,
    // },
    {
        field: 'total_invoice_value',
        headerName: 'Total Invoice Value',
        flex: 1,
        minWidth: 180,
        align: 'center',
        headerAlign: 'center',
        filterable: true,
    },
    {
        field: 'total_taxable_value',
        headerName: 'Total Taxable Value',
        flex: 1,
        minWidth: 180,
        align: 'center',
        headerAlign: 'center',
        filterable: true,
    },
    {
        field: 'integrated_tax',
        headerName: 'Integrated Tax',
        flex: 1,
        minWidth: 180,
        align: 'center',
        headerAlign: 'center',
        filterable: true,
    },
    {
        field: 'central_tax',
        headerName: 'Central Tax',
        flex: 1,
        minWidth: 180,
        align: 'center',
        headerAlign: 'center',
        filterable: true,
    },
    {
        field: 'state_ut_tax',
        headerName: 'State Tax',
        flex: 1,
        minWidth: 180,
        align: 'center',
        headerAlign: 'center',
        filterable: true,
    },
    {
        field: 'return_period',
        headerName: 'Return Period',
        flex: 1,
        minWidth: 180,
        align: 'center',
        headerAlign: 'center',
        filterable: true,
    },
    {
        field: 'status',
        headerName: 'Status',
        flex: 1,
        minWidth: 180,
        align: 'center',
        headerAlign: 'center',
        filterable: true,

    },
    {
        field: 'remarks_by_recipient',
        headerName: 'Remarks by Recipient',
        flex: 1,
        minWidth: 180,
        align: 'center',
        headerAlign: 'center',
        filterable: true,

    },
    {
        field: 'gstr1_recon_status',
        headerName: 'GSTR 1 Recon Status',
        flex: 1,
        minWidth: 180,
        align: 'center',
        headerAlign: 'center',
        filterable: true,
    },
];


const pendingColumns = [
    {
        field: 'record_type',
        headerName: 'Record Type',
        flex: 1,
        minWidth: 150,
        align: 'center',
        headerAlign: 'center',
        filterable: true,
    },
    {
        field: 'trade_legal_name',
        headerName: 'Legal Name',
        flex: 1,
        minWidth: 150,
        align: 'center',
        headerAlign: 'center',
        filterable: true,
    },
    {
        field: 'recipient_gstin',
        headerName: 'GSTIN',
        flex: 1,
        minWidth: 200,
        align: 'center',
        headerAlign: 'center',
        filterable: true,
    },
    {
        field: 'invoice_number',
        headerName: 'Invoice Number',
        flex: 1,
        minWidth: 180,
        align: 'center',
        headerAlign: 'center',
        filterable: true,
    },
    {
        field: 'invoice_date',
        headerName: 'Invoice Date',
        flex: 1,
        minWidth: 180,
        align: 'center',
        headerAlign: 'center',
        filterable: true,
    },
    // {
    //     field: 'reported_in_form',
    //     headerName: 'Reported in Form',
    //     flex: 1,
    //     minWidth: 180,
    //     align: 'center',
    //     headerAlign: 'center',
    //     filterable: true,
    // },
    {
        field: 'total_invoice_value',
        headerName: 'Total Invoice Value',
        flex: 1,
        minWidth: 180,
        align: 'center',
        headerAlign: 'center',
        filterable: true,
    },
    {
        field: 'total_taxable_value',
        headerName: 'Total Taxable Value',
        flex: 1,
        minWidth: 180,
        align: 'center',
        headerAlign: 'center',
        filterable: true,
    },
    {
        field: 'integrated_tax',
        headerName: 'Integrated Tax',
        flex: 1,
        minWidth: 180,
        align: 'center',
        headerAlign: 'center',
        filterable: true,
    },
    {
        field: 'central_tax',
        headerName: 'Central Tax',
        flex: 1,
        minWidth: 180,
        align: 'center',
        headerAlign: 'center',
        filterable: true,
    },
    {
        field: 'state_ut_tax',
        headerName: 'State Tax',
        flex: 1,
        minWidth: 180,
        align: 'center',
        headerAlign: 'center',
        filterable: true,
    },
    {
        field: 'return_period',
        headerName: 'Return Period',
        flex: 1,
        minWidth: 180,
        align: 'center',
        headerAlign: 'center',
        filterable: true,
    },
    {
        field: 'status',
        headerName: 'Status',
        flex: 1,
        minWidth: 180,
        align: 'center',
        headerAlign: 'center',
        filterable: true,

    },
    {
        field: 'remarks_by_recipient',
        headerName: 'Remarks by Recipient',
        flex: 1,
        minWidth: 180,
        align: 'center',
        headerAlign: 'center',
        filterable: true,

    },
    {
        field: 'gstr1_recon_status',
        headerName: 'GSTR 1 Recon Status',
        flex: 1,
        minWidth: 180,
        align: 'center',
        headerAlign: 'center',
        filterable: true,
    },

];

const noactionColumns = [
    {
        field: 'record_type',
        headerName: 'Record Type',
        flex: 1,
        minWidth: 150,
        align: 'center',
        headerAlign: 'center',
        filterable: true,
    },
    {
        field: 'trade_legal_name',
        headerName: 'Legal Name',
        flex: 1,
        minWidth: 150,
        align: 'center',
        headerAlign: 'center',
        filterable: true,
    },
    {
        field: 'recipient_gstin',
        headerName: 'GSTIN',
        flex: 1,
        minWidth: 200,
        align: 'center',
        headerAlign: 'center',
        filterable: true,
    },
    {
        field: 'invoice_number',
        headerName: 'Invoice Number',
        flex: 1,
        minWidth: 180,
        align: 'center',
        headerAlign: 'center',
        filterable: true,
    },
    {
        field: 'invoice_date',
        headerName: 'Invoice Date',
        flex: 1,
        minWidth: 180,
        align: 'center',
        headerAlign: 'center',
        filterable: true,
    },
    // {
    //     field: 'reported_in_form',
    //     headerName: 'Reported in Form',
    //     flex: 1,
    //     minWidth: 180,
    //     align: 'center',
    //     headerAlign: 'center',
    //     filterable: true,
    // },
    {
        field: 'total_invoice_value',
        headerName: 'Total Invoice Value',
        flex: 1,
        minWidth: 180,
        align: 'center',
        headerAlign: 'center',
        filterable: true,
    },
    {
        field: 'total_taxable_value',
        headerName: 'Total Taxable Value',
        flex: 1,
        minWidth: 180,
        align: 'center',
        headerAlign: 'center',
        filterable: true,
    },
    {
        field: 'integrated_tax',
        headerName: 'Integrated Tax',
        flex: 1,
        minWidth: 180,
        align: 'center',
        headerAlign: 'center',
        filterable: true,
    },
    {
        field: 'central_tax',
        headerName: 'Central Tax',
        flex: 1,
        minWidth: 180,
        align: 'center',
        headerAlign: 'center',
        filterable: true,
    },
    {
        field: 'state_ut_tax',
        headerName: 'State Tax',
        flex: 1,
        minWidth: 180,
        align: 'center',
        headerAlign: 'center',
        filterable: true,
    },
    {
        field: 'return_period',
        headerName: 'Return Period',
        flex: 1,
        minWidth: 180,
        align: 'center',
        headerAlign: 'center',
        filterable: true,
    },
    {
        field: 'status',
        headerName: 'Status',
        flex: 1,
        minWidth: 180,
        align: 'center',
        headerAlign: 'center',
        filterable: true,

    },
    {
        field: 'remarks_by_recipient',
        headerName: 'Remarks by Recipient',
        flex: 1,
        minWidth: 180,
        align: 'center',
        headerAlign: 'center',
        filterable: true,

    },
    {
        field: 'gstr1_recon_status',
        headerName: 'GSTR 1 Recon Status',
        flex: 1,
        minWidth: 180,
        align: 'center',
        headerAlign: 'center',
        filterable: true,
    },

];


const CustomToolbar = ({ activeTab, onSubmit, onSave, isSubmitDisabled, isSaveDisabled, onError, errorLogId, onReset, isResetDisabled }) => (
    <Box
        sx={{
            display: 'flex',
            justifyContent: 'space-between',
            width: '100%',
            height: '60px',
            flexWrap: 'wrap',
            gap: 1,
            padding: '3px 10px',
            backgroundColor: '#ffffff',
            borderRadius: '4px',
            boxShadow: '0 2px 5px rgba(0,0,0,0.1)',
        }}
    >
        <Box sx={{ display: 'flex', gap: 1 }}>
            <GridToolbarColumnsButton
                sx={{
                    borderColor: '#1976d2',
                    color: '#1976d2',
                    borderRadius: '4px',
                    padding: '2px 4px',
                    '&:hover': { borderColor: '#1565c0', backgroundColor: '#e3f2fd' },
                }}
            />
            <GridToolbarFilterButton
                sx={{
                    borderColor: '#1976d2',
                    color: '#1976d2',
                    borderRadius: '4px',
                    padding: '2px 4px',
                    '&:hover': { borderColor: '#1565c0', backgroundColor: '#e3f2fd' },
                }}
                PopperProps={{
                    style: { zIndex: 1300 },
                }}
            />
            <GridToolbarDensitySelector
                sx={{
                    borderColor: '#1976d2',
                    color: '#1976d2',
                    borderRadius: '4px',
                    padding: '2px 4px',
                    '&:hover': { borderColor: '#1565c0', backgroundColor: '#e3f2fd' },
                }}
            />
        </Box>
        {/* {activeTab === 'imsReport' && (
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                <button
                    className="button-outlined-primary"
                    style={{
                        width: 'auto',
                        height: '36px',
                        padding: '0 16px',
                        whiteSpace: 'nowrap',
                        fontSize: '14px',
                        opacity: errorLogId === null ? 0.5 : 1,
                        cursor: errorLogId === null ? 'not-allowed' : 'pointer',
                    }}
                    onClick={onError}
                    disabled={errorLogId === null}
                >
                    Error Report
                </button>
                <button
                    className="button-outlined-primary"
                    style={{
                        width: '42%',
                        height: '59%',
                        marginTop: '1%',
                        opacity: isResetDisabled ? 0.5 : 1, // Use isResetDisabled for opacity
                        cursor: isResetDisabled ? 'not-allowed' : 'pointer',
                    }}
                    onClick={onReset}
                    disabled={isResetDisabled} // Use isResetDisabled prop
                >
                    Reset
                </button>
                <button
                    className="button-outlined-primary"
                    style={{
                        width: '42%',
                        height: '59%',
                        marginTop: '1%',
                        // opacity: isSaveDisabled ? 1 : 1,
                        // cursor: isSaveDisabled ? 'not-allowed' : 'pointer',
                    }}
                    onClick={onSave}
                // disabled={isSaveDisabled}
                >
                    Save
                </button>
                <button
                    className="button-outlined-primary"
                    style={{
                        width: '42%',
                        height: '59%',
                        marginTop: '1%',
                        // opacity: isSubmitDisabled ? 1 : 1,
                        // cursor: isSubmitDisabled ? 'not-allowed' : 'pointer',
                    }}
                    onClick={onSubmit}
                // disabled={isSubmitDisabled}
                >
                    Push
                </button>
            </div>
        )} */}
    </Box>
);

const CustomNoRowsOverlay = () => {
    console.log('Rendering CustomNoRowsOverlay');
    return (
        <Box
            sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100%',
                fontSize: '16px',
                fontWeight: 'medium',
                color: 'text.secondary',
            }}
        >
            No Data Available
        </Box>
    );
};


const IMSReport = ({ recordForTable, loaderForTable, getApiImsReport, activeTab, errorLogId, ims_recon_id, tax_period }) => {
    const [snackbar, setSnackbar] = useState({
        open: false,
        message: '',
        severity: 'info',
    });

    const { ims_outward_recon_id } = useParams();
    // Normalize status values to match dropdown options (case-sensitive)


    useEffect(() => {
        if (ims_outward_recon_id) {
            localStorage.setItem("ims_recon_id", ims_outward_recon_id);
        }

        getApiImsReport()
    }, []);



    const handleCloseSnackbar = () => {
        setSnackbar({ ...snackbar, open: false });
    };


    return (
        <>
            <Box sx={{ height: '65vh', width: '100%', marginTop: '4px' }}>
                <DataGridPro
                    rows={recordForTable}
                    columns={columns}
                    // getRowId={(row) => row.ID}
                    loading={loaderForTable}
                    errorLogId={errorLogId}
                    disableRowSelectionOnClick
                    onRowSelectionModelChange={() => { }}
                    sx={{
                        maxHeight: '65vh',
                        '& .MuiDataGrid-columnHeaders': {
                            color: '#fff',
                            fontWeight: 'bold',
                            cursor: 'pointer',
                            textAlign: 'right',
                            zIndex: 1000,
                        },
                        '& .MuiDataGrid-columnHeader': {
                            position: 'relative',
                            textAlign: 'right',
                            width: '100%',
                            fontWeight: 'bold',
                            background: 'linear-gradient(135deg, #03406d 0%, #03406d  10%)',
                        },
                        '& .MuiDataGrid-columnHeaderTitle': {
                            color: '#fff',
                        },
                        '& .MuiDataGrid-sortIcon': {
                            opacity: 'inherit !important',
                        },
                        '& .MuiDataGrid-iconButtonContainer': {
                            visibility: 'visible',
                        },
                        '& .MuiDataGrid-menuIconButton': {
                            opacity: '1 !important',
                            visibility: 'visible !important',
                            display: 'flex !important',
                        },
                        '& .MuiDataGrid-columnHeaderIcon': {
                            color: '#fff',
                        },
                        '& .MuiDataGrid-columnHeader .MuiIconButton-root': {
                            color: '#fff',
                        },
                        '& .MuiDataGrid-row:nth-of-type(odd)': {
                            backgroundColor: '#f9f9f9',
                        },
                        '& .MuiDataGrid-row:nth-of-type(even)': {
                            backgroundColor: '#ffffff',
                        },
                        '& .MuiDataGrid-cell': {
                            padding: '8px',
                            textAlign: 'center',
                        },
                        '& .MuiDataGrid-footerContainer': {
                            backgroundColor: '#f0f0f0',
                        },
                        '& .MuiCheckbox-root': {
                            color: '#1976d2',
                        },
                        '& .MuiDataGrid-row:hover': {
                            backgroundColor: '#d3e3fc',
                            cursor: 'pointer',
                        },
                    }}
                    components={{
                        Toolbar: () => (
                            <CustomToolbar
                                activeTab={activeTab}
                            // onSubmit={handleSubmit}
                            // onSave={handleSave}
                            // onReset={handleReset}
                            // isSubmitDisabled={areButtonsDisabled}
                            // isSaveDisabled={areButtonsDisabled}
                            // isResetDisabled={!isResetEnabled} // Pass new prop for Reset button
                            // errorLogId={errorLogId}
                            // onError={handleErrorReport}
                            />
                        ),
                        NoRowsOverlay: CustomNoRowsOverlay,
                    }}
                />
            </Box>
            <Snackbar
                open={snackbar.open}
                autoHideDuration={6000}
                onClose={handleCloseSnackbar}
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
            >
                <Alert onClose={handleCloseSnackbar} severity={snackbar.severity} sx={{ width: '100%' }}>
                    {snackbar.message}
                </Alert>
            </Snackbar>
        </>
    );
};



const IMSAccepted = ({ recordForAcceptedTable, loaderForTable, getApiImsAccepted, pagination, handlePageChange, handleRowsPerPageChange, ims_recon_id, activeTab }) => {
    // State to hold filtered data and search term
    const [filteredRecords, setFilteredRecords] = useState(recordForAcceptedTable);
    const [pageSize, setPageSize] = useState(25);
    const [currentPage, setCurrentPage] = useState(0);
    const [searchTerm, setSearchTerm] = useState('');
    const { ims_outward_recon_id } = useParams();


    const handlePageSizeChange = (newPageSize) => {
        setPageSize(newPageSize);
    };


    // Update filteredRecords when recordForAcceptedTable changes
    useEffect(() => {
        if (ims_outward_recon_id) {
            localStorage.setItem("ims_recon_id", ims_outward_recon_id);
            console.log(ims_recon_id);

        }

        getApiImsAccepted()
    }, []);


    // Search handler
    const handleSearchEvent = (e) => {
        const term = e.target.value.trim().toLowerCase();
        setSearchTerm(term);

        if (!term) {
            setFilteredRecords(recordForAcceptedTable);
            return;
        }

        const filtered = recordForAcceptedTable.filter((v) => {
            return (
                String(v.record_type || "").toLowerCase().includes(term) ||
                String(v.trade_legal_name || "").toLowerCase().includes(term) ||
                String(v.recipient_gstin || "").toLowerCase().includes(term) ||
                String(v.original_invoice_number || "").toLowerCase().includes(term) ||
                String(v.invoice_number || "").toLowerCase().includes(term) ||
                String(v.invoice_date || "").toLowerCase().includes(term) ||
                String(v.reported_in_form || "").toLowerCase().includes(term) ||
                String(v.return_period || "").toLowerCase().includes(term) ||
                String(v.status || "").toLowerCase().includes(term)
            );
        });

        setFilteredRecords(filtered);
    };

    return (
        <>
            <Box sx={{ height: '65vh', width: '100%', marginTop: '4px' }}>
                <DataGridPro
                    rows={recordForAcceptedTable}
                    columns={acceptColumns}
                    // getRowId={(row) => row.ID}
                    loading={loaderForTable}
                    pagination
                    pageSize={pageSize}
                    pageSizeOptions={[5, 10, 25, 50]}
                    onPageSizeChange={handlePageSizeChange}
                    onPageChange={handlePageChange}
                    disableRowSelectionOnClick
                    onRowSelectionModelChange={() => { }}
                    // localeText={{
                    //     toolbarDensity: 'Size',
                    //     toolbarDensityLabel: 'Size',
                    //     toolbarDensityCompact: 'Small',
                    //     toolbarDensityStandard: 'Medium',
                    //     toolbarDensityComfortable: 'Large',
                    //     footerRowSelected: () => '',
                    // }}
                    sx={{
                        maxHeight: '65vh',
                        '& .MuiDataGrid-columnHeaders': {
                            color: '#fff',
                            fontWeight: 'bold',
                            cursor: 'pointer',
                            textAlign: 'right',
                            zIndex: 1000,
                        },
                        '& .MuiDataGrid-columnHeader': {
                            position: 'relative',
                            textAlign: 'right',
                            width: '100%',
                            fontWeight: 'bold',
                            background: 'linear-gradient(135deg, #03406d 0%, #03406d  10%)',
                        },
                        '& .MuiDataGrid-columnHeaderTitle': {
                            color: '#fff',
                        },
                        '& .MuiDataGrid-sortIcon': {
                            opacity: 'inherit !important',
                        },
                        '& .MuiDataGrid-iconButtonContainer': {
                            visibility: 'visible',
                        },
                        '& .MuiDataGrid-menuIconButton': {
                            opacity: '1 !important',
                            visibility: 'visible !important',
                            display: 'flex !important',
                        },
                        '& .MuiDataGrid-columnHeaderIcon': {
                            color: '#fff',
                        },
                        '& .MuiDataGrid-columnHeader .MuiIconButton-root': {
                            color: '#fff',
                        },
                        '& .MuiDataGrid-row:nth-of-type(odd)': {
                            backgroundColor: '#f9f9f9',
                        },
                        '& .MuiDataGrid-row:nth-of-type(even)': {
                            backgroundColor: '#ffffff',
                        },
                        '& .MuiDataGrid-cell': {
                            padding: '8px',
                            textAlign: 'center',
                        },
                        '& .MuiDataGrid-footerContainer': {
                            backgroundColor: '#f0f0f0',
                        },
                        '& .MuiCheckbox-root': {
                            color: '#1976d2',
                        },
                        '& .MuiDataGrid-row:hover': {
                            backgroundColor: '#d3e3fc',
                            cursor: 'pointer',
                        },
                    }}
                    components={{
                        Toolbar: CustomToolbar,
                        NoRowsOverlay: CustomNoRowsOverlay,
                    }}
                />
            </Box>
        </>
    );
};



const IMSRejected = ({ recordForRejectedTable, loaderForTable, getApiImsRejected, handleStatus, pagination, handlePageChange, handleRowsPerPageChange, activeTab }) => {
    // State to hold filtered data and search term
    const [filteredRecords, setFilteredRecords] = useState(recordForRejectedTable);
    const [pageSize, setPageSize] = useState(25);
    const [currentPage, setCurrentPage] = useState(0);
    const [searchTerm, setSearchTerm] = useState('');
    const { ims_outward_recon_id } = useParams();


    const handlePageSizeChange = (newPageSize) => {
        setPageSize(newPageSize);
    };


    // Update filteredRecords when recordForRejectedTable changes
    // useEffect(() => {
    //     setFilteredRecords(recordForRejectedTable);
    // }, [recordForRejectedTable]);

    useEffect(() => {
        if (ims_outward_recon_id) {
            localStorage.setItem("ims_recon_id", ims_outward_recon_id);


        }

        // getApiImsRejected()
    }, []);

    // Search handler
    const handleSearchEvent = (e) => {
        const term = e.target.value.trim().toLowerCase();
        setSearchTerm(term);

        if (!term) {
            // If search term is empty, reset to original records
            setFilteredRecords(recordForRejectedTable);
            return;
        }

        const filtered = recordForRejectedTable.filter((v) => {
            return (
                String(v.record_type || "").toLowerCase().includes(term) ||
                String(v.trade_legal_name || "").toLowerCase().includes(term) ||
                String(v.recipient_gstin || "").toLowerCase().includes(term) ||
                String(v.original_invoice_number || "").toLowerCase().includes(term) ||
                String(v.invoice_number || "").toLowerCase().includes(term) ||
                String(v.invoice_date || "").toLowerCase().includes(term) ||
                String(v.reported_in_form || "").toLowerCase().includes(term) ||
                String(v.return_period || "").toLowerCase().includes(term) ||
                String(v.status || "").toLowerCase().includes(term)
            );
        });

        setFilteredRecords(filtered);
    };

    return (
        <Box sx={{ height: '65vh', width: '100%', marginTop: '4px' }}>
            <DataGridPro
                rows={recordForRejectedTable}
                columns={rejectColumns}
                // getRowId={(row) => row.ID}
                loading={loaderForTable}
                pagination
                pageSize={pageSize}
                pageSizeOptions={[5, 10, 25, 50]}
                onPageSizeChange={handlePageSizeChange}
                onPageChange={handlePageChange}
                disableRowSelectionOnClick
                onRowSelectionModelChange={() => { }}
                // localeText={{
                //     toolbarDensity: 'Size',
                //     toolbarDensityLabel: 'Size',
                //     toolbarDensityCompact: 'Small',
                //     toolbarDensityStandard: 'Medium',
                //     toolbarDensityComfortable: 'Large',
                //     footerRowSelected: () => '',
                // }}
                sx={{
                    maxHeight: '65vh',
                    '& .MuiDataGrid-columnHeaders': {
                        color: '#fff',
                        fontWeight: 'bold',
                        cursor: 'pointer',
                        textAlign: 'right',
                        zIndex: 1000,
                    },
                    '& .MuiDataGrid-columnHeader': {
                        position: 'relative',
                        textAlign: 'right',
                        width: '100%',
                        fontWeight: 'bold',
                        background: 'linear-gradient(135deg, #03406d 0%, #03406d  10%)',
                    },
                    '& .MuiDataGrid-columnHeaderTitle': {
                        color: '#fff',
                    },
                    '& .MuiDataGrid-sortIcon': {
                        opacity: 'inherit !important',
                    },
                    '& .MuiDataGrid-iconButtonContainer': {
                        visibility: 'visible',
                    },
                    '& .MuiDataGrid-menuIconButton': {
                        opacity: '1 !important',
                        visibility: 'visible !important',
                        display: 'flex !important',
                    },
                    '& .MuiDataGrid-columnHeaderIcon': {
                        color: '#fff',
                    },
                    '& .MuiDataGrid-columnHeader .MuiIconButton-root': {
                        color: '#fff',
                    },
                    '& .MuiDataGrid-row:nth-of-type(odd)': {
                        backgroundColor: '#f9f9f9',
                    },
                    '& .MuiDataGrid-row:nth-of-type(even)': {
                        backgroundColor: '#ffffff',
                    },
                    '& .MuiDataGrid-cell': {
                        padding: '8px',
                        textAlign: 'center',
                    },
                    '& .MuiDataGrid-footerContainer': {
                        backgroundColor: '#f0f0f0',
                    },
                    '& .MuiCheckbox-root': {
                        color: '#1976d2',
                    },
                    '& .MuiDataGrid-row:hover': {
                        backgroundColor: '#d3e3fc',
                        cursor: 'pointer',
                    },
                }}
                components={{
                    Toolbar: () => <CustomToolbar activeTab={activeTab} />,
                    NoRowsOverlay: CustomNoRowsOverlay,
                }}
            />
        </Box>
    );
};

const IMSPending = ({ recordForPendingTable, loaderForTable, handleStatus, reconId, getApiImsPending, pagination, handlePageChange, handleRowsPerPageChange, activeTab }) => {
    // State to hold filtered data and search term
    const [filteredRecords, setFilteredRecords] = useState(recordForPendingTable);
    const [searchTerm, setSearchTerm] = useState('');
    const [pageSize, setPageSize] = useState(25);
    const [currentPage, setCurrentPage] = useState(0);
    const { ims_outward_recon_id } = useParams();



    // Update filteredRecords when recordForPendingTable changes
    useEffect(() => {
        setFilteredRecords(recordForPendingTable);
    }, [recordForPendingTable]);

    // Search handler
    const handleSearchEvent = (e) => {
        const term = e.target.value.trim().toLowerCase();
        setSearchTerm(term);

        if (!term) {
            // If search term is empty, reset to original records
            setFilteredRecords(recordForPendingTable);
            return;
        }

        const filtered = recordForPendingTable.filter((v) => {
            return (
                String(v.record_type || "").toLowerCase().includes(term) ||
                String(v.trade_legal_name || "").toLowerCase().includes(term) ||
                String(v.recipient_gstin || "").toLowerCase().includes(term) ||
                String(v.original_invoice_number || "").toLowerCase().includes(term) ||
                String(v.invoice_number || "").toLowerCase().includes(term) ||
                String(v.invoice_date || "").toLowerCase().includes(term) ||
                String(v.reported_in_form || "").toLowerCase().includes(term) ||
                String(v.return_period || "").toLowerCase().includes(term) ||
                String(v.status || "").toLowerCase().includes(term)
            );
        });

        setFilteredRecords(filtered);
    };


    const handlePageSizeChange = (newPageSize) => {
        setPageSize(newPageSize);
    };

    return (
        <Box sx={{ height: '65vh', width: '100%', marginTop: '4px' }}>
            <DataGridPro
                rows={recordForPendingTable}
                columns={pendingColumns}
                // getRowId={(row) => row.ID}
                loading={loaderForTable}
                pagination
                pageSize={pageSize}
                pageSizeOptions={[5, 10, 25, 50]}
                onPageSizeChange={handlePageSizeChange}
                onPageChange={handlePageChange}
                disableRowSelectionOnClick
                onRowSelectionModelChange={() => { }}
                // localeText={{
                //     toolbarDensity: 'Size',
                //     toolbarDensityLabel: 'Size',
                //     toolbarDensityCompact: 'Small',
                //     toolbarDensityStandard: 'Medium',
                //     toolbarDensityComfortable: 'Large',
                //     footerRowSelected: () => '',
                // }}
                sx={{
                    maxHeight: '65vh',
                    '& .MuiDataGrid-columnHeaders': {
                        color: '#fff',
                        fontWeight: 'bold',
                        cursor: 'pointer',
                        textAlign: 'right',
                        zIndex: 1000,
                    },
                    '& .MuiDataGrid-columnHeader': {
                        position: 'relative',
                        textAlign: 'right',
                        width: '100%',
                        fontWeight: 'bold',
                        background: 'linear-gradient(135deg, #03406d 0%, #03406d  10%)',
                    },
                    '& .MuiDataGrid-columnHeaderTitle': {
                        color: '#fff',
                    },
                    '& .MuiDataGrid-sortIcon': {
                        opacity: 'inherit !important',
                    },
                    '& .MuiDataGrid-iconButtonContainer': {
                        visibility: 'visible',
                    },
                    '& .MuiDataGrid-menuIconButton': {
                        opacity: '1 !important',
                        visibility: 'visible !important',
                        display: 'flex !important',
                    },
                    '& .MuiDataGrid-columnHeaderIcon': {
                        color: '#fff',
                    },
                    '& .MuiDataGrid-columnHeader .MuiIconButton-root': {
                        color: '#fff',
                    },
                    '& .MuiDataGrid-row:nth-of-type(odd)': {
                        backgroundColor: '#f9f9f9',
                    },
                    '& .MuiDataGrid-row:nth-of-type(even)': {
                        backgroundColor: '#ffffff',
                    },
                    '& .MuiDataGrid-cell': {
                        padding: '8px',
                        textAlign: 'center',
                    },
                    '& .MuiDataGrid-footerContainer': {
                        backgroundColor: '#f0f0f0',
                    },
                    '& .MuiCheckbox-root': {
                        color: '#1976d2',
                    },
                    '& .MuiDataGrid-row:hover': {
                        backgroundColor: '#d3e3fc',
                        cursor: 'pointer',
                    },
                }}
                components={{
                    Toolbar: () => <CustomToolbar activeTab={activeTab} />,
                    NoRowsOverlay: CustomNoRowsOverlay,
                }}
            />
        </Box>
    );
};

const IMSNoAction = ({ recordForNoActionTable, loaderForTable, getApiImsNoAction, handleStatus, reconId, pagination, handlePageChange, handleRowsPerPageChange, activeTab }) => {
    // State to hold filtered data and search term
    const [filteredRecords, setFilteredRecords] = useState(recordForNoActionTable);
    const [searchTerm, setSearchTerm] = useState('');
    const [pageSize, setPageSize] = useState(25);
    const [currentPage, setCurrentPage] = useState(0);

    // Update filteredRecords when recordForNoActionTable changes
    useEffect(() => {
        setFilteredRecords(recordForNoActionTable);
    }, [recordForNoActionTable]);



    const handlePageSizeChange = (newPageSize) => {
        setPageSize(newPageSize);
    };

    // Search handler
    const handleSearchEvent = (e) => {
        const term = e.target.value.trim().toLowerCase();
        setSearchTerm(term);

        if (!term) {
            // If search term is empty, reset to original records
            setFilteredRecords(recordForNoActionTable);
            return;
        }

        const filtered = recordForNoActionTable.filter((v) => {
            return (
                String(v.record_type || "").toLowerCase().includes(term) ||
                String(v.trade_legal_name || "").toLowerCase().includes(term) ||
                String(v.recipient_gstin || "").toLowerCase().includes(term) ||
                String(v.original_invoice_number || "").toLowerCase().includes(term) ||
                String(v.invoice_number || "").toLowerCase().includes(term) ||
                String(v.invoice_date || "").toLowerCase().includes(term) ||
                String(v.reported_in_form || "").toLowerCase().includes(term) ||
                String(v.return_period || "").toLowerCase().includes(term) ||
                String(v.status || "").toLowerCase().includes(term)
            );
        });

        setFilteredRecords(filtered);
    };

    return (
        <Box sx={{ height: '65vh', width: '100%', marginTop: '4px' }}>
            <DataGridPro
                rows={recordForNoActionTable}
                columns={noactionColumns}
                // getRowId={(row) => row.ID}
                loading={loaderForTable}
                pagination
                pageSize={pageSize}
                pageSizeOptions={[5, 10, 25, 50]}
                onPageSizeChange={handlePageSizeChange}
                onPageChange={handlePageChange}
                disableRowSelectionOnClick
                onRowSelectionModelChange={() => { }}
                // localeText={{
                //     toolbarDensity: 'Size',
                //     toolbarDensityLabel: 'Size',
                //     toolbarDensityCompact: 'Small',
                //     toolbarDensityStandard: 'Medium',
                //     toolbarDensityComfortable: 'Large',
                //     footerRowSelected: () => '',
                // }}
                sx={{
                    maxHeight: '65vh',
                    '& .MuiDataGrid-columnHeaders': {
                        color: '#fff',
                        fontWeight: 'bold',
                        cursor: 'pointer',
                        textAlign: 'right',
                        zIndex: 1000,
                    },
                    '& .MuiDataGrid-columnHeader': {
                        position: 'relative',
                        textAlign: 'right',
                        width: '100%',
                        fontWeight: 'bold',
                        background: 'linear-gradient(135deg, #03406d 0%, #03406d  10%)',
                    },
                    '& .MuiDataGrid-columnHeaderTitle': {
                        color: '#fff',
                    },
                    '& .MuiDataGrid-sortIcon': {
                        opacity: 'inherit !important',
                    },
                    '& .MuiDataGrid-iconButtonContainer': {
                        visibility: 'visible',
                    },
                    '& .MuiDataGrid-menuIconButton': {
                        opacity: '1 !important',
                        visibility: 'visible !important',
                        display: 'flex !important',
                    },
                    '& .MuiDataGrid-columnHeaderIcon': {
                        color: '#fff',
                    },
                    '& .MuiDataGrid-columnHeader .MuiIconButton-root': {
                        color: '#fff',
                    },
                    '& .MuiDataGrid-row:nth-of-type(odd)': {
                        backgroundColor: '#f9f9f9',
                    },
                    '& .MuiDataGrid-row:nth-of-type(even)': {
                        backgroundColor: '#ffffff',
                    },
                    '& .MuiDataGrid-cell': {
                        padding: '8px',
                        textAlign: 'center',
                    },
                    '& .MuiDataGrid-footerContainer': {
                        backgroundColor: '#f0f0f0',
                    },
                    '& .MuiCheckbox-root': {
                        color: '#1976d2',
                    },
                    '& .MuiDataGrid-row:hover': {
                        backgroundColor: '#d3e3fc',
                        cursor: 'pointer',
                    },
                }}
                components={{
                    Toolbar: () => <CustomToolbar activeTab={activeTab} />,
                    NoRowsOverlay: CustomNoRowsOverlay,
                }}
            />
        </Box>
    );
};


export default function IMSDashboard() {
    const history = useHistory();
    const { ims_outward_recon_id } = useParams();
    const location = useLocation();
    const { ims_recon_id } = useParams();
    const [activeTab, setActiveTab] = useState("dashboard");
    const [recordForLogTable, setRecordForLogTable] = useState([]);
    const [recordForTable, setRecordForTable] = useState([]);
    const [recordForAcceptedTable, setRecordForAcceptedTable] = useState([]);
    const [recordForRejectedTable, setRecordForRejectedTable] = useState([]);
    const [recordForPendingTable, setRecordForPendingTable] = useState([]);
    const [recordForNoActionTable, setRecordForNoActionTable] = useState([]);
    const [loaderForTable, setLoaderForTable] = useState(false);
    const [chartData, setChartData] = useState(null);
    const [reconId, setReconId] = useState(null);
    const [taxPeriod, setTaxPeriod] = useState(null);
    const [showTabs, setShowTabs] = useState(false);
    const [showLogTable, setShowLogTables] = useState(true);
    const [businessEntityId, setBusinessEntityId] = useState(localStorage.getItem("business_entity_id"));
    const [selectedReconId, setSelectedReconId] = useState(null);
    const [modalOpen, setModalOpen] = useState(false);
    const [availableMonths, setAvailableMonths] = useState([]);
    const [selectedMonths, setSelectedMonths] = useState([]);
    const [recordForExpandTable, setRecordForExpandTable] = useState([]);
    const [tableData, setTableData] = useState([]);
    const iconColors = ['#3B82F6', '#EF4444', '#F59E0B', '#6B7280'];
    const [metrics, setMetrics] = useState({
        accepted: { count: 0, TotalInvoiceValue: 0, TotalIGST: 0, TotalCGST: 0, TotalSGST: 0 },
        rejected: { count: 0, TotalInvoiceValue: 0, TotalIGST: 0, TotalCGST: 0, TotalSGST: 0 },
        pending: { count: 0, TotalInvoiceValue: 0, TotalIGST: 0, TotalCGST: 0, TotalSGST: 0 },
        noAction: { count: 0, TotalInvoiceValue: 0, TotalIGST: 0, TotalCGST: 0, TotalSGST: 0 },
    });
    const [errorLogId, setErrorLogId] = useState(null);
    const [username, setUserName] = useState("");
    const [openOTPModal, setOpenOTPModal] = useState(false);
    const [openEstablisConnectionDrawer, setOpenEstablisConnectionDrawer] =
        useState(false);
    const [authAPiResData, setAuthApiResData] = useState({});
    const [auth_otp, setAuthOTP] = useState("");
    const [authToken, setAuthToken] = useState("");
    const [otpApiData, setOtpApidata] = useState({});
    const [vyanaList, setVyanaList] = useState([]);
    // Updated pagination state
    const [pagination, setPagination] = useState({
        page: 0, // 0-based for TablePagination
        rowsPerPage: 10, // Set to 10 as requested
        total_count: 0,
        total_pages: 1,
    });
    const [snackbar, setSnackbar] = useState({
        open: false,
        message: '',
        severity: 'info'
    });
    const [establishConnectionButton, setEstablisConnectionButton] = useState(
        "button-outlined-secondary"
    );

    const maxCount = Math.max(
        metrics.accepted.count,
        metrics.rejected.count,
        metrics.pending.count,
        metrics.noAction.count,
        1
    );

    const statusCards = [
        { status: "Accepted", data: metrics.accepted },
        { status: "Rejected", data: metrics.rejected },
        { status: "Pending", data: metrics.pending },
        { status: "No Action", data: metrics.noAction },
    ];
    const [successMessage, setSuccessMessage] = useState("");
    const form = useRef("form");

    const style = {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: 400,
        bgcolor: "background.paper",
        border: "2px solid #000",
        boxShadow: 24,
        p: 4,
        zIndex: 1300, // Increased z-index to ensure modal visibility
    };


    useEffect(() => {
        if (ims_outward_recon_id) {
            localStorage.setItem("ims_recon_id", ims_outward_recon_id);  // sync
            getApiList(ims_outward_recon_id);
            // fetchReportData(ims_outward_recon_id);
        }
    }, [ims_outward_recon_id]);


    const formatNumber = (num) => {
        if (num === undefined || num === null) return '0';
        return num.toLocaleString('en-IN');
    };

    // Updated handlePageChange to match TablePagination signature
    const handlePageChange = (event, newPage) => {
        setPagination((prev) => ({ ...prev, page: newPage }));
    };

    const handleRowsPerPageChange = (event) => {
        const newRowsPerPage = parseInt(event.target.value, 10);
        setPagination((prev) => ({
            ...prev,
            page: 0, // Reset to first page
            rowsPerPage: newRowsPerPage,
        }));
    };


    //   const vyanaAuthHandler = () => {
    //     let payload = {
    //       user_name: username,
    //       business_entity_id: localStorage.getItem("business_entity_id"),
    //       app_key: otpApiData.app_key,
    //       transaction_id: otpApiData.transaction_id,
    //       otp: auth_otp,
    //     };

    //     console.log("vyana/authenticate payload:", payload); // Debug payload

    //     axios
    //       .post("/vyana/authenticate", payload)
    //       .then((res) => {
    //         if (res.data.status === true) {
    //           setOpenOTPModal(false);
    //           setOpenEstablisConnectionDrawer(false);
    //           setEstablisConnectionButton("button-connection-established");
    //           setAuthApiResData({
    //             ...authAPiResData,
    //             sek: res.data.sek,
    //             auth_token: res.data.auth_token,
    //           });
    //           getApiVyanaList();
    //           setSnackbar({
    //             open: true,
    //             message: res.data.message,
    //             severity: 'success'
    //           });
    //           setUserName(""); // Reset username after successful authentication
    //           setTimeout(() => {
    //             setEstablisConnectionButton("button-outlined-secondary");
    //           }, 300000);
    //         } else {
    //           setSnackbar({
    //             open: true,
    //             message: res.data.error,
    //             severity: 'error'
    //           });
    //           setOpenOTPModal(true);
    //           setEstablisConnectionButton("button-outlined-secondary");
    //           setUserName(""); // Reset username after failed authentication
    //         }
    //       })
    //       .catch((error) => {
    //         console.log(error.response?.message || error.message);
    //         setOpenOTPModal(true);
    //         setEstablisConnectionButton("button-outlined-secondary");
    //         setUserName(""); // Reset username after error
    //         setSnackbar({
    //           open: true,
    //           message: error.response?.message || error.message,
    //           severity: 'error'
    //         });
    //       });
    //   };

    const closeEstablisConnectionDrawerHamdler = () => {
        setOpenEstablisConnectionDrawer(false);
        // Removed setUserName("") to preserve username
    };

    const closeOptModalHandler = () => {
        setAuthOTP("");
        setOpenOTPModal(false);
    };

    const vyanaAuthHandler = () => {
        let payload = {
            user_name: username,
            business_entity_id: localStorage.getItem("business_entity_id"),
            app_key: otpApiData.app_key,
            transaction_id: otpApiData.transaction_id,
            otp: auth_otp,
        };

        console.log("vyana/authenticate payload:", payload); // Debug payload

        axios
            .post("/vyana/authenticate", payload)
            .then((res) => {
                if (res.data.status === true) {
                    setOpenOTPModal(false);
                    setOpenEstablisConnectionDrawer(false);
                    setEstablisConnectionButton("button-connection-established");
                    setAuthApiResData({
                        ...authAPiResData,
                        sek: res.data.sek,
                        auth_token: res.data.auth_token,
                    });
                    getApiVyanaList();
                    setSnackbar({
                        open: true,
                        message: res.data.message,
                        severity: 'success'
                    });
                    setUserName(""); // Reset username after successful authentication
                    setTimeout(() => {
                        setEstablisConnectionButton("button-outlined-secondary");
                    }, 300000);
                } else {
                    setSnackbar({
                        open: true,
                        message: res.data.error,
                        severity: 'error'
                    });
                    setOpenOTPModal(true);
                    setEstablisConnectionButton("button-outlined-secondary");
                    setUserName(""); // Reset username after failed authentication
                }
            })
            .catch((error) => {
                console.log(error.response?.message || error.message);
                setOpenOTPModal(true);
                setEstablisConnectionButton("button-outlined-secondary");
                setUserName(""); // Reset username after error
                setSnackbar({
                    open: true,
                    message: error.response?.message || error.message,
                    severity: 'error'
                });
            });
    };

    const getApiVyanaList = () => {
        axios
            .get(`/vyana/get_list/${localStorage.getItem("business_entity_id")}`)
            .then((res) => {
                if (res.data.status === true) {
                    setVyanaList(res.data.data);
                } else {
                }
            })
            .catch((error) => {
            });
    };

    const getOtpForAuthHandler = () => {
        let payload = {
            user_name: username,
            business_entity_id: localStorage.getItem("business_entity_id"),
        };

        console.log("vyana/send_otp payload:", payload); // Debug payload

        axios
            .post("/vyana/send_otp", payload)
            .then((res) => {
                console.log("API Response:", res.data);
                if (res.data.status === true) {
                    if (res.data.is_authenticated === true && res.data.is_otp_sent === false) {
                        console.log("Case 1: is_authenticated true, is_otp_sent false");
                        setOpenOTPModal(false);
                        if (res.data.message === "Connection established.") {
                            setSuccessMessage(res.data.message);
                            setAuthToken(res.data.auth_token);
                        }
                        setSnackbar({
                            open: true,
                            message: res.data.message,
                            severity: 'success'
                        });
                        closeEstablisConnectionDrawerHamdler();
                    } else if (res.data.is_authenticated === false && res.data.is_otp_sent === true) {
                        console.log("Case 2: Setting openOTPModal to true");
                        closeEstablisConnectionDrawerHamdler();
                        console.log("setting otp model Open:");
                        setOpenOTPModal(true);
                        setSnackbar({
                            open: true,
                            message: res.data.message,
                            severity: 'success'
                        });
                    } else {
                        console.log("Case 3: Else block, setting openOTPModal and otpApiData");
                        setOpenOTPModal(true);
                        setOtpApidata({
                            ...otpApiData,
                            transaction_id: res.data.transaction_id,
                            app_key: res.data.app_key,
                        });
                    }
                } else {
                    console.log("API status false, error:", res.data.error);
                    setSnackbar({
                        open: true,
                        message: res.data.error,
                        severity: 'error'
                    });
                    setOpenOTPModal(false);
                    setEstablisConnectionButton("button-outlined-secondary");
                }
            })
            .catch((error) => {
                console.error("API Error:", error.response?.message || error.message);
                setSnackbar({
                    open: true,
                    message: error.response?.message || error.message,
                    severity: 'error'
                });
            });
    };

    const handleCloseSnackbar = () => {
        setSnackbar({ ...snackbar, open: false });
    };

    useEffect(() => {
        // if (ims_recon_id) {
        //     console.log('Initializing with ims_recon_id from URL:', ims_recon_id);
        //     setReconId(ims_recon_id);
        //     // setTaxPeriod(tax_period);
        //     setShowTabs(true);
        //     setShowLogTables(false);
        //     setPagination((prev) => ({ ...prev, page: 0 }));
        //     setLoaderForTable(true);
        //     getApiList(ims_outward_recon_id);
        // } else {
        //     console.log('No ims_recon_id in URL, showing LogTable');
        //     setShowTabs(false);
        //     setShowLogTables(true);
        //     setReconId(null);
        //     getApiLogReport();
        // }
    }, []);

    useEffect(() => {
        // Check if returning from child with tab state
        if (location.state?.returnTab === 'imsReport') {
            setActiveTab('imsReport');
        }
    }, [location]);


    const handleStatus = (ims_recon_id, newStatus) => async () => {
        console.log("handleStatus ims_recon_id:", ims_recon_id, "newStatus:", newStatus);
        if (typeof ims_recon_id === 'string' || typeof ims_recon_id === 'number') {
            if (newStatus) {
                // Directly update status if provided (from dropdown)
                try {
                    setLoaderForTable(true);
                    await axios.post(`/update_recon_status/${ims_recon_id}`, {
                        status: newStatus.toLowerCase(),
                    });
                    setSnackbar({
                        open: true,
                        message: `${newStatus} updated successfully`,
                        severity: 'success'
                    });
                    if (reconId) {
                        getApiImsRepository(ims_outward_recon_id, pagination.page, pagination.rowsPerPage);
                    }
                } catch (error) {
                    console.error('Error updating status:', error);
                    setSnackbar({
                        open: true,
                        message: error.response?.data?.message || `Failed to update status to ${newStatus}`,
                        severity: 'error'
                    });
                } finally {
                    setLoaderForTable(false);
                }
            } else {
                // Open modal if no status is provided (e.g., from VisibilityIcon)
                setSelectedReconId(ims_recon_id);
                // setModalOpen(true);
            }
        } else {
            setSnackbar({
                open: true,
                message: "Invalid Recon ID",
                severity: 'error'
            });
        }
    };

    const getApiLogReport = () => {
        setLoaderForTable(true);
        axios
            .get(`/ims_summary_report/${ims_outward_recon_id}/${businessEntityId}`)
            .then((response) => {
                console.log('getApiLogReport response:', response.data);
                setRecordForLogTable(response.data.data || []);
                setErrorLogId(response.data.data?.length > 0 ? response.data.data[0].error_log_id : null);
                setLoaderForTable(false);
                const logEntry = response.data.data?.find(entry => entry.ims_recon_id === ims_recon_id);
                if (logEntry && logEntry.tax_period) {
                    console.log('Setting tax_period:', logEntry.tax_period);
                    setTaxPeriod(logEntry.tax_period);
                }
                if (response.data && response.data.Message) {
                    setSnackbar({
                        open: true,
                        message: response.data.Message,
                        severity: 'success'
                    });
                    if (response.data.ims_recon_id || response.data.tax_period) {
                        setReconId(response.data.ims_recon_id);
                        setTaxPeriod(response.data.tax_period)
                    }
                }
            })
            .catch((error) => {
                console.error('Error fetching log report:', error);
                setLoaderForTable(false);
                setSnackbar({
                    open: true,
                    message: 'Error fetching IMS log report',
                    severity: 'error'
                });
            });
    };

    const getApiList = (ims_outward_recon_id) => {
        const business_entity_id = localStorage.getItem("business_entity_id")
        axios
            .get(`/ims_outward_card_data/${ims_outward_recon_id}/${business_entity_id}`)
            .then((response) => {
                console.log('getApiList response:', response.data);
                const metricsData = {
                    accepted: { count: 0, TotalInvoiceValue: 0, TotalIGST: 0, TotalCGST: 0, TotalSGST: 0 },
                    rejected: { count: 0, TotalInvoiceValue: 0, TotalIGST: 0, TotalCGST: 0, TotalSGST: 0 },
                    pending: { count: 0, TotalInvoiceValue: 0, TotalIGST: 0, TotalCGST: 0, TotalSGST: 0 },
                    noAction: { count: 0, TotalInvoiceValue: 0, TotalIGST: 0, TotalCGST: 0, TotalSGST: 0 },
                };

                response.data.forEach((item) => {
                    switch (item.Status) {
                        case 'Accepted':
                            metricsData.accepted.count = item.Count;
                            metricsData.accepted.TotalInvoiceValue = item.TotalInvoiceValue;
                            metricsData.accepted.TotalIGST = item.TotalIGST;
                            metricsData.accepted.TotalCGST = item.TotalCGST;
                            metricsData.accepted.TotalSGST = item.TotalSGST;
                            break;
                        case 'Rejected':
                            metricsData.rejected.count = item.Count;
                            metricsData.rejected.TotalInvoiceValue = item.TotalInvoiceValue;
                            metricsData.rejected.TotalIGST = item.TotalIGST;
                            metricsData.rejected.TotalCGST = item.TotalCGST;
                            metricsData.rejected.TotalSGST = item.TotalSGST;
                            break;
                        case 'Pending':
                            metricsData.pending.count = item.Count;
                            metricsData.pending.TotalInvoiceValue = item.TotalInvoiceValue;
                            metricsData.pending.TotalIGST = item.TotalIGST;
                            metricsData.pending.TotalCGST = item.TotalCGST;
                            metricsData.pending.TotalSGST = item.TotalSGST;
                            break;
                        case 'No Action':
                            metricsData.noAction.count = item.Count;
                            metricsData.noAction.TotalInvoiceValue = item.TotalInvoiceValue;
                            metricsData.noAction.TotalIGST = item.TotalIGST;
                            metricsData.noAction.TotalCGST = item.TotalCGST;
                            metricsData.noAction.TotalSGST = item.TotalSGST;
                            break;
                        default:
                            break;
                    }
                });

                setMetrics(metricsData);
            })
            .catch((error) => {
                console.error('Error fetching card data:', error);
            });
    };


    const getSummary = (ims_recon_id, periods) => {
        const payload = {
            ims_recon_id: ims_recon_id,
            period: periods || [],
        };
        console.log('Sending payload to /ims_summary_by_period:', payload);
        setLoaderForTable(true);
        axios
            .post(`/ims_summary_by_period`, payload)
            .then((response) => {
                console.log('Full API response:', response.data);
                console.log('Available Months:', response.data.available_months);
                console.log('Table Data:', response.data.results);
                const newAvailableMonths = response.data.available_months || [];
                setAvailableMonths(newAvailableMonths);
                setRecordForExpandTable(response.data.results || []);

                // Process chart data dynamically
                const results = response.data.results || [];

                // Extract unique GSTR_2B_Recon_Remarks and Status
                const categoriesSet = new Set();
                const statusesSet = new Set();
                results.forEach((item) => {
                    const remark = item.GSTR_2B_Recon_Remarks || '';
                    const status = item.Status || '';
                    categoriesSet.add(remark);
                    statusesSet.add(status);
                });

                const categories = Array.from(categoriesSet);
                const statuses = Array.from(statusesSet);

                // Define the metrics to plot
                const metrics = [
                    { key: 'Count_of_Invoice_Number', name: 'Count of Invoice Number', yAxis: 0 },
                    { key: 'Integrated_Tax', name: 'Integrated Tax (₹)', yAxis: 1 },
                    { key: 'Central_Tax', name: 'Central Tax (₹)', yAxis: 1 },
                    { key: 'State_UT_Tax', name: 'State/UT Tax (₹)', yAxis: 1 },
                    { key: 'Cess', name: 'Cess (₹)', yAxis: 1 },
                ];

                // Initialize series: one series per status for each metric
                const series = [];
                metrics.forEach((metric) => {
                    statuses.forEach((status) => {
                        series.push({
                            name: `${status} (${metric.name})`,
                            metricName: metric.name,
                            data: Array(categories.length).fill(0),
                            yAxis: metric.yAxis,
                        });
                    });
                });

                // Populate series data
                results.forEach((item) => {
                    const remark = item.GSTR_2B_Recon_Remarks || '';
                    const status = item.Status || '';
                    const categoryIndex = categories.indexOf(remark);
                    const statusIndex = statuses.indexOf(status);

                    metrics.forEach((metric, metricIndex) => {
                        const seriesIndex = metricIndex * statuses.length + statusIndex;
                        series[seriesIndex].data[categoryIndex] = item[metric.key] || 0;
                    });
                });

                // Filter out series where all data points are 0
                const filteredSeries = series.filter((s) =>
                    s.data.some((value) => value !== 0)
                );

                const chartData = {
                    categories,
                    series: filteredSeries,
                };

                console.log('Transformed chartData:', chartData);
                setChartData(chartData);

                setLoaderForTable(false);
            })
            .catch((error) => {
                console.error('Error fetching summary:', error);
                setLoaderForTable(false);
                setSnackbar({
                    open: true,
                    message: error.response?.data?.message || 'Error fetching IMS summary',
                    severity: 'error'
                });
            });
    };

    const onClickBack = () => {
        history.push('/IMSOutwardReconciliation');
    };


    const getApiImsRepository = () => {
        const business_entity_id = localStorage.getItem("business_entity_id");
        const ims_outward_recon_id = localStorage.getItem("ims_recon_id");

        if (!ims_outward_recon_id) {
            setSnackbar({ open: true, message: "Missing Reconciliation ID", severity: "error" });
            return;
        }

        setLoaderForTable(true);

        axios
            ?.get(`/ims_summary_report/${ims_outward_recon_id}/${business_entity_id}`)
            .then((res) => {
                console.log("IMS Report Response:", res.data);

                if ((res.data.status === true || res.data.status === "true") && Array.isArray(res.data.records)) {
                    setRecordForTable(res.data.records);
                } else {
                    setRecordForTable([]);
                    setSnackbar({
                        open: true,
                        message: res.data.message || "No records found",
                        severity: "info"
                    });
                }
            })
            .catch((error) => {
                setRecordForTable([]);
                setSnackbar({
                    open: true,
                    message: error.response?.data?.message || "Failed to load report",
                    severity: "error"
                });
            })
            .finally(() => setLoaderForTable(false));
    };

    const getApiImsAccepted = () => {
        const business_entity_id = localStorage.getItem("business_entity_id")
        const ims_outward_recon_id = localStorage.getItem("ims_recon_id");

        setLoaderForTable(true);
        if (!ims_outward_recon_id) {
            setSnackbar({ open: true, message: "Missing Reconciliation ID", severity: "error" });
            return;
        }

        axios
            .get(`/get_outward_recon_accepted/${ims_outward_recon_id}/${business_entity_id}`)
            .then((res) => {
                console.log("Full IMS Accepted Report Response:", res.data);

                // Check if response has status and records is an array
                if ((res.data.status === true || res.data.status === "true") && Array.isArray(res.data.records)) {
                    // Set records for the table
                    setRecordForAcceptedTable(res.data.records);
                    // setSnackbar({
                    //     open: true,
                    //     message: res.data.message,
                    //     severity: 'success'
                    // });
                } else {
                    console.warn("Invalid response structure:", res.data);
                    setSnackbar({
                        open: true,
                        message: res.data.message || "Invalid API response: Expected records array",
                        severity: 'error',
                    });
                }
                setLoaderForTable(false);
            })
            .catch((error) => {
                console.error("Error fetching IMS accepted summary:", {
                    message: error.message,
                    response: error.response?.data,
                    status: error.response?.status,
                });
                setLoaderForTable(false);
                setSnackbar({
                    open: true,
                    message: error.response?.data?.message || "Error fetching IMS accepted summary",
                    severity: 'error',
                });
            });
    };

    const getApiImsRejected = () => {
        const business_entity_id = localStorage.getItem("business_entity_id")
        const ims_outward_recon_id = localStorage.getItem("ims_recon_id");

        console.log("Fetching IMS Rejected Report with reconId:", ims_recon_id);
        setLoaderForTable(true);
        axios
            .get(`/get_outward_recon_rejected/${ims_outward_recon_id}/${business_entity_id}`)
            .then((res) => {
                console.log("IMS Rejected Report Response:", res.data);
                if (res.data.status && Array.isArray(res.data.records)) {
                    setRecordForRejectedTable(res.data.records);
                    // setSnackbar({
                    //     open: true,
                    //     message: res.data.message,
                    //     severity: 'success'
                    // });
                } else {
                    setSnackbar({
                        open: true,
                        message: res.data.message || "Invalid API response: Expected records array",
                        severity: 'error'
                    });
                }
                setLoaderForTable(false);
            })
            .catch((error) => {
                console.error("Error fetching IMS rejected summary:", error);
                setLoaderForTable(false);
                setSnackbar({
                    open: true,
                    message: error.response?.data?.message || "Error fetching IMS rejected summary",
                    severity: 'error'
                });
            });
    };

    const getApiImsPending = () => {
        const business_entity_id = localStorage.getItem("business_entity_id")
        const ims_outward_recon_id = localStorage.getItem("ims_recon_id");
        console.log("Fetching IMS Pending Report with reconId:", ims_recon_id);
        setLoaderForTable(true);
        axios
            .get(`/get_outward_recon_pending/${ims_outward_recon_id}/${business_entity_id}`)
            .then((res) => {
                console.log("IMS Pending Report Response:", res.data);
                if (res.data.status && Array.isArray(res.data.records)) {
                    setRecordForPendingTable(res.data.records);
                    // setSnackbar({
                    //     open: true,
                    //     message: res.data.message,
                    //     severity: 'success'
                    // });
                } else {
                    setSnackbar({
                        open: true,
                        message: res.data.message || "Invalid API response: Expected records array",
                        severity: 'error'
                    });
                }
                setLoaderForTable(false);
            })
            .catch((error) => {
                console.error("Error fetching IMS pending summary:", error);
                setLoaderForTable(false);
                setSnackbar({
                    open: true,
                    message: error.response?.data?.message || "Error fetching IMS pending summary",
                    severity: 'error'
                });
            });
    };

    const getApiImsNoAction = () => {
        const business_entity_id = localStorage.getItem("business_entity_id");
        const ims_outward_recon_id = localStorage.getItem("ims_recon_id");

        if (!ims_outward_recon_id || !business_entity_id) {
            setSnackbar({
                open: true,
                message: "Missing required IDs. Please try again.",
                severity: "error"
            });
            return;
        }

        console.log("Fetching IMS No Action Report → reconId:", ims_outward_recon_id, "entityId:", business_entity_id);

        setLoaderForTable(true);

        axios
            .get(`/get_outward_recon_no_action/${ims_outward_recon_id}/${business_entity_id}`)
            .then((res) => {
                console.log("Full API Response:", res);
                console.log("res.data →", res.data);

                // Critical Fix: Many backends (especially in GST/IMS apps) wrap data inside res.data.data
                const apiResponse = res.data?.data || res.data;

                // Safety checks
                const isSuccess = apiResponse.status === true || apiResponse.status === "true";
                const hasRecords = Array.isArray(apiResponse.records);

                if (isSuccess && hasRecords) {
                    setRecordForNoActionTable(apiResponse.records);
                    console.log("Records loaded successfully:", apiResponse.records.length, "records");
                } else {
                    // No records or invalid structure
                    setRecordForNoActionTable([]);
                    setSnackbar({
                        open: true,
                        message: apiResponse.message || "No records found for this period",
                        severity: "info"
                    });
                }
            })
            .catch((error) => {
                console.error("API Error →", error);

                let errorMsg = "Failed to fetch No Action records";

                if (error.response) {
                    // Server responded with error status
                    errorMsg = error.response.data?.message || error.response.data?.error || errorMsg;
                } else if (error.request) {
                    // No response received
                    errorMsg = "No response from server. Check your internet connection.";
                } else {
                    errorMsg = error.message;
                }

                setSnackbar({
                    open: true,
                    message: errorMsg,
                    severity: "error"
                });
            })
            .finally(() => {
                setLoaderForTable(false); // ← Only call ONCE, in finally
            });
    };

    const closeEstablisConnectionDrawerHandler = () => {
        setOpenEstablisConnectionDrawer(false);
    }



    const fetchChartData = () => {
        setTimeout(() => {
            const mockChartData = {
                exactMatch: {
                    invoiceCount: 606,
                    integratedTax: 142,
                    centralTax: 606,
                    stateTax: 482,
                    cess: 89,
                },
                mismatch: {
                    invoiceCount: 198,
                    integratedTax: 42,
                    centralTax: 227,
                    stateTax: 164,
                    cess: 56,
                },
                missingInBooks: {
                    invoiceCount: 55,
                    integratedTax: 0,
                    centralTax: 0,
                    stateTax: 0,
                    cess: 0,
                },
                pending: {
                    invoiceCount: 1840,
                    integratedTax: 479,
                    centralTax: 3101955,
                    stateTax: 3019655,
                    cess: 417,
                },
            };
            setChartData(mockChartData);
        }, 2000);
    };

    useEffect(() => {
        getApiLogReport();
    }, []);

    useEffect(() => {
        // console.log("Active Tab:", activeTab, "Recon ID:", reconId);
        const ims_outward_recon_id = localStorage.getItem("ims_recon_id");
        // console.log("Active Tab:", activeTab, "Recon ID:", taxPeriod);
        if (ims_outward_recon_id) {
            if (activeTab === "imsReport") {
                getApiImsRepository(ims_outward_recon_id, pagination.page, pagination.rowsPerPage);
            } else if (activeTab === "accepted") {
                getApiImsAccepted(ims_outward_recon_id, pagination.page, pagination.rowsPerPage);
            } else if (activeTab === "rejected") {
                getApiImsRejected(ims_outward_recon_id, pagination.page, pagination.rowsPerPage);
            } else if (activeTab === "pending") {
                getApiImsPending(ims_outward_recon_id, pagination.page, pagination.rowsPerPage);
            } else if (activeTab === "noAction") {
                getApiImsNoAction(ims_outward_recon_id, pagination.page, pagination.rowsPerPage);
            } else if (activeTab === "dashboard") {
                fetchChartData();
                getApiList(ims_outward_recon_id);
                // Call getSummary with the current selectedMonths
                getSummary(reconId, selectedMonths);
            }
        }
    }, [activeTab, reconId, pagination.page, pagination.rowsPerPage, selectedMonths]);
    const cards = [
        {
            title: 'Accepted',
            value: metrics.accepted.count,
            icon: <CheckIcon sx={{ color: 'white' }} />,
            iconColor: iconColors[0],
        },
        {
            title: 'Rejected',
            value: metrics.rejected.count,
            icon: <ClearIcon sx={{ color: 'white' }} />,
            iconColor: iconColors[1],
        },
        {
            title: 'Pending',
            value: metrics.pending.count,
            icon: <HourglassBottomIcon sx={{ color: 'white' }} />,
            iconColor: iconColors[2],
        },
        {
            title: 'No Action',
            value: metrics.noAction.count,
            icon: <WarningIcon sx={{ color: 'white' }} />,
            iconColor: iconColors[3],
        },
    ];


    const cardsTotal = [
        {
            title: 'Accepted',
            value: `₹${formatNumber(metrics.accepted.TotalInvoiceValue)}`,
            icon: <CheckIcon sx={{ color: 'white' }} />,
            iconColor: iconColors[0],
        },
        {
            title: 'Rejected',
            value: `₹${formatNumber(metrics.rejected.TotalInvoiceValue)}`,
            icon: <ClearIcon sx={{ color: 'white' }} />,
            iconColor: iconColors[1],
        },
        {
            title: 'Pending',
            value: `₹${formatNumber(metrics.pending.TotalInvoiceValue)}`,
            icon: <HourglassBottomIcon sx={{ color: 'white' }} />,
            iconColor: iconColors[2],
        },
        {
            title: 'No Action',
            value: `₹${formatNumber(metrics.noAction.TotalInvoiceValue)}`,
            icon: <WarningIcon sx={{ color: 'white' }} />,
            iconColor: iconColors[3],
        },
    ];

    return (
        <div style={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}>
            {/* {showLogTable && (
                <>
                    <button
                        className="button-outlined-primary"
                        style={{ marginLeft: "0px", width: "10%" }}
                        onClick={onClickRunIms}
                    >
                        RUN IMS RECON
                    </button>

                    <div style={{ display: "flex", justifyContent: "center", padding: "20px" }}>
                        <LogTable
                            recordForLogTable={recordForLogTable}
                            loaderForTable={loaderForTable}
                            getApiLogReport={getApiLogReport}
                            handleViewData={handleViewData}
                            onClickExport={onClickExport}
                        />
                    </div>
                </>
            )} */}
            <ToastContainer />
            <Snackbar
                open={snackbar.open}
                autoHideDuration={6000}
                onClose={handleCloseSnackbar}
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
            >
                <Alert onClose={handleCloseSnackbar} severity={snackbar.severity} sx={{ width: '100%' }}>
                    {snackbar.message}
                </Alert>
            </Snackbar>
            {/* {showTabs && ( */}
            <div>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px 0' }}>
                    <button
                        className="button-outlined-primary"
                        style={{ marginLeft: "0px", width: "10%" }}
                        onClick={onClickBack}
                    >
                        BACK
                    </button>

                    {/* {
                            successMessage === "Connection established." ? (
                                <Button variant="contained" color="success" style={{ fontSize: '13px', padding: '4px 8px', bottom: '4px' }}>
                                    Connection Established
                                </Button>
                            ) : (
                                <button
                                    className={establishConnectionButton}
                                    onClick={() => setOpenEstablisConnectionDrawer(true)}
                                >
                                    {establishConnectionButton === "button-outlined-secondary"
                                        ? "Establish Connection"
                                        : "Connection Established"
                                    }
                                </button>
                            )
                        } */}


                    <Dialog
                        open={openEstablisConnectionDrawer}
                        onClose={closeEstablisConnectionDrawerHandler}
                        fullWidth
                        maxWidth="xs"
                        PaperProps={{
                            sx: {
                                borderRadius: 2,
                                boxShadow: 24,
                                p: 2,
                                bgcolor: 'background.default',
                                zIndex: 1300, // Ensure dialog appears above other elements
                            },
                        }}
                    >
                        <DialogTitle style={{ fontWeight: '600' }}>Establish Connection</DialogTitle>
                        <DialogContent>
                            <ValidatorForm
                                ref={form}
                                onSubmit={getOtpForAuthHandler}
                                onError={(errors) => console.log(errors)}
                            >
                                <Inputfield
                                    textLabel="User Name"
                                    inputType="text"
                                    name="user_name"
                                    value={username}
                                    textOnchangeFunction={(e) => setUserName(e.target.value)}
                                    requiredField="*"
                                    validator={["required"]}
                                    errorMsg={["This field is required"]}
                                />
                                <div className="mt-20">
                                    <button className="button-primary" type="submit">
                                        Submit
                                    </button>
                                    <button
                                        className="button-outlined-secondary"
                                        type="button"
                                        onClick={closeEstablisConnectionDrawerHandler}
                                    >
                                        Close
                                    </button>
                                </div>
                            </ValidatorForm>
                        </DialogContent>
                    </Dialog>


                    <Modal open={openOTPModal}>
                        <Box sx={style}>
                            <ValidatorForm
                                ref={form}
                                onSubmit={vyanaAuthHandler}
                                onError={(errors) => console.log("ValidatorForm errors:", errors)}
                            >
                                <Inputfield
                                    textLabel="OTP"
                                    inputType="text"
                                    name="OTP"
                                    value={auth_otp}
                                    textOnchangeFunction={(e) => setAuthOTP(e.target.value)}
                                    requiredField="*"
                                    validator={["required"]}
                                    errorMsg={["This field is required"]}
                                />
                                <div className="mt-20">
                                    <button className="button-primary" type="submit">
                                        Submit
                                    </button>
                                    <button
                                        className="button-outlined-secondary"
                                        type="button"
                                        onClick={closeOptModalHandler}
                                    >
                                        Close
                                    </button>
                                </div>
                            </ValidatorForm>
                        </Box>
                    </Modal>

                    {/* <button
                            className="button-outlined-primary"
                            style={{ marginLeft: "0px", width: "10%" }}
                            onClick={onClickExport}
                        >
                            EXPORT
                        </button> */}
                    {/* {activeTab === 'imsReport' && (
                        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '16px', marginTop: '16px' }}>
                            {successMessage === 'Connection established.' ? (
                                <button
                                    className="button-outlined-primary"
                                    color="success"
                                    sx={{ fontSize: '13px', padding: '4px 8px', mb: '4px', backgroundColor: '#191970' }}
                                    aria-label="Connection established"
                                    style={{ backgroundColor: '#03406d', color: 'white' }}
                                >
                                    Connection Established
                                </button>
                                //                     <button
                                //     className="button-outlined-primary"
                                //     style={{ marginLeft: "0px", width: "15%", marginTop: "1px" }}
                                //     onClick={this.handleBack}
                                //   >
                                //     BACK
                                //   </button>
                            ) : (
                                <button
                                    className="button-outlined-primary"
                                    onClick={() => setOpenEstablisConnectionDrawer(true)}

                                    sx={{ fontSize: '13px', padding: '4px 8px', mb: '4px' }}
                                    aria-label="Establish connection"
                                >
                                    {establishConnectionButton === 'button-outlined-secondary'
                                        ? 'Establish Connection'
                                        : 'Connection Established'}
                                </button>
                            )}
                            <button
                                endIcon={<AddCircleIcon />}
                                className="button-outlined-primary"
                                sx={{ alignSelf: 'flex-end' }}
                                onClick={navigateToExcelPairing}
                                aria-label="Manual upload"
                            >
                                Manual Upload
                            </button>
                        </div>

                        // <Button
                        //     endIcon={<AddCircleIcon />}
                        //     color="success"
                        //     variant="contained"
                        //     style={{ alignSelf: 'flex-end', backgroundColor: '#00c853' }}
                        //     onClick={navigareToExcelPairing}
                        // >
                        //     Manual Upload
                        // </Button>
                    )} */}
                </div>
                <div
                    style={{
                        display: "flex",
                        justifyContent: "space-around",
                        alignItems: "center",
                        backgroundColor: "rgb(243, 245, 248)",
                        padding: "0px 0",
                        borderRadius: "25px",
                        margin: "10px",
                        boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
                        border: "1px solid #d1d5db",
                    }}
                >
                    <button
                        onClick={() => setActiveTab("dashboard")}
                        style={{
                            flex: 1,
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            position: "relative",
                            padding: "10px",
                            color: activeTab === "dashboard" ? "#fff" : "#333",
                            fontSize: "14px",
                            background:
                                activeTab === "dashboard"
                                    ? "linear-gradient(135deg, #03406d 0%, #a28bc4 100%)"
                                    : "transparent",
                            border: "none",
                            borderRadius: "25px",
                            cursor: "pointer",
                            transition: "color 0.3s",
                        }}
                    >
                        <i className="fas fa-tachometer-alt" style={{ fontSize: "20px", marginRight: activeTab === "dashboard" ? "5px" : "0", color: activeTab === "dashboard" ? "#fff" : "#333" }}></i>
                        {activeTab === "dashboard" ? <span>Dashboard</span> : <span style={{ color: "#333" }}>Dashboard</span>}
                        {activeTab === "dashboard" && (
                            <span
                                style={{
                                    position: "absolute",
                                    top: "5px",
                                    right: "5px",
                                    width: "8px",
                                    height: "8px",
                                    backgroundColor: "#ff0000",
                                    borderRadius: "50%",
                                }}
                            ></span>
                        )}
                    </button>
                    <button
                        onClick={() => setActiveTab("imsReport")}
                        style={{
                            flex: 1,
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            position: "relative",
                            padding: "10px",
                            color: activeTab === "imsReport" ? "#fff" : "#333",
                            fontSize: "14px",
                            background: activeTab === "imsReport" ? "linear-gradient(135deg, #03406d 0%, #a28bc4 100%)"
                                : "transparent",
                            border: "none",
                            borderRadius: "25px",
                            cursor: "pointer",
                            transition: "color 0.3s",
                        }}
                    >
                        <i className="fas fa-file-alt" style={{ fontSize: "20px", marginRight: activeTab === "imsReport" ? "5px" : "0", color: activeTab === "imsReport" ? "#fff" : "#333" }}></i>
                        {activeTab === "imsReport" ? <span>IMS Report</span> : <span style={{ color: "#333" }}>IMS Report</span>}
                        {activeTab === "imsReport" && (
                            <span
                                style={{
                                    position: "absolute",
                                    top: "5px",
                                    right: "5px",
                                    width: "8px",
                                    height: "8px",
                                    backgroundColor: "#ff0000",
                                    borderRadius: "50%",
                                }}
                            ></span>
                        )}
                    </button>
                    <button
                        onClick={() => setActiveTab("accepted")}
                        style={{
                            flex: 1,
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            position: "relative",
                            padding: "10px",
                            color: activeTab === "accepted" ? "#fff" : "#333",
                            fontSize: "14px",
                            background: activeTab === "accepted" ? "linear-gradient(135deg, #03406d 0%, #a28bc4 100%)"
                                : "transparent",
                            border: "none",
                            borderRadius: "25px",
                            cursor: "pointer",
                            transition: "color 0.3s",
                        }}
                    >
                        <i className="fas fa-check-circle" style={{ fontSize: "20px", marginRight: activeTab === "accepted" ? "5px" : "0", color: activeTab === "accepted" ? "#fff" : "#333" }}></i>
                        {activeTab === "accepted" ? <span>Accepted</span> : <span style={{ color: "#333" }}>Accepted</span>}
                        {activeTab === "accepted" && (
                            <span
                                style={{
                                    position: "absolute",
                                    top: "5px",
                                    right: "5px",
                                    width: "8px",
                                    height: "8px",
                                    backgroundColor: "#ff0000",
                                    borderRadius: "50%",
                                }}
                            ></span>
                        )}
                    </button>
                    <button
                        onClick={() => setActiveTab("rejected")}
                        style={{
                            flex: 1,
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            position: "relative",
                            padding: "10px",
                            color: activeTab === "rejected" ? "#fff" : "#333",
                            fontSize: "14px",
                            background: activeTab === "rejected" ? "linear-gradient(135deg, #03406d 0%, #a28bc4 100%)"
                                : "transparent",
                            border: "none",
                            borderRadius: "25px",
                            cursor: "pointer",
                            transition: "color 0.3s",
                        }}
                    >
                        <i className="fas fa-times-circle" style={{ fontSize: "20px", marginRight: activeTab === "rejected" ? "5px" : "0", color: activeTab === "rejected" ? "#fff" : "#333" }}></i>
                        {activeTab === "rejected" ? <span>Rejected</span> : <span style={{ color: "#333" }}>Rejected</span>}
                        {activeTab === "rejected" && (
                            <span
                                style={{
                                    position: "absolute",
                                    top: "5px",
                                    right: "5px",
                                    width: "8px",
                                    height: "8px",
                                    backgroundColor: "#ff0000",
                                    borderRadius: "50%",
                                }}
                            ></span>
                        )}
                    </button>
                    <button
                        onClick={() => setActiveTab("pending")}
                        style={{
                            flex: 1,
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            position: "relative",
                            padding: "10px",
                            color: activeTab === "pending" ? "#fff" : "#333",
                            fontSize: "14px",
                            background: activeTab === "pending" ? "linear-gradient(135deg, #03406d 0%, #a28bc4 100%)"
                                : "transparent",
                            border: "none",
                            borderRadius: "25px",
                            cursor: "pointer",
                            transition: "color 0.3s",
                        }}
                    >
                        <i className="fas fa-hourglass-half" style={{ fontSize: "20px", marginRight: activeTab === "pending" ? "5px" : "0", color: activeTab === "pending" ? "#fff" : "#333" }}></i>
                        {activeTab === "pending" ? <span>Pending</span> : <span style={{ color: "#333" }}>Pending</span>}
                        {activeTab === "pending" && (
                            <span
                                style={{
                                    position: "absolute",
                                    top: "5px",
                                    right: "5px",
                                    width: "8px",
                                    height: "8px",
                                    backgroundColor: "#ff0000",
                                    borderRadius: "50%",
                                }}
                            ></span>
                        )}
                    </button>
                    <button
                        onClick={() => setActiveTab("noAction")}
                        style={{
                            flex: 1,
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            position: "relative",
                            padding: "10px",
                            color: activeTab === "noAction" ? "#fff" : "#333",
                            fontSize: "14px",
                            background: activeTab === "noAction" ? "linear-gradient(135deg, #03406d 0%, #a28bc4 100%)"
                                : "transparent",
                            border: "none",
                            borderRadius: "25px",
                            cursor: "pointer",
                            transition: "color 0.3s",
                        }}
                    >
                        <i className="fas fa-exclamation-circle" style={{ fontSize: "20px", marginRight: activeTab === "noAction" ? "5px" : "0", color: activeTab === "noAction" ? "#fff" : "#333" }}></i>
                        {activeTab === "noAction" ? <span>No Action</span> : <span style={{ color: "#333" }}>No Action</span>}
                        {activeTab === "noAction" && (
                            <span
                                style={{
                                    position: "absolute",
                                    top: "5px",
                                    right: "5px",
                                    width: "8px",
                                    height: "8px",
                                    backgroundColor: "#ff0000",
                                    borderRadius: "50%",
                                }}
                            ></span>
                        )}
                    </button>
                </div>

                <div style={{ flex: 1, padding: "20px" }}>
                    {activeTab === "dashboard" && (
                        <>
                            {/* <Grid container spacing={6} justifyContent="center" sx={{ padding: 2 }}>
                                {cards.map((card, index) => (
                                    <Grid item xs={12} sm={6} md={3} key={index}>
                                        <DashboardCard
                                            title={card.title}
                                            value={card.value}
                                            icon={card.icon}
                                            iconColor={card.iconColor}
                                        />
                                    </Grid>
                                ))}
                            </Grid> */}

                            {/* Circular Metric Cards Section */}
                            <Box sx={{ padding: 2, mt: 2 }}>
                                <Typography variant="h5" sx={{ fontWeight: 'bold', color: '#1e293b', mb: 1 }}>
                                    Tax Composition Overview
                                </Typography>
                                <Typography variant="body2" sx={{ color: '#64748b', mb: 3 }}>
                                    Detailed breakdown of invoice statuses and values
                                </Typography>

                                <Grid container spacing={4} justifyContent="center">
                                    {statusCards.map((item) => (
                                        <Grid item xs={12} sm={6} md={3} key={item.status}>
                                            <CircularMetricCard
                                                status={item.status}
                                                count={item.data.count}
                                                totalValue={item.data.TotalInvoiceValue}
                                                totalIGST={item.data.TotalIGST}
                                                totalCGST={item.data.TotalCGST}
                                                totalSGST={item.data.TotalSGST}
                                                maxCount={maxCount}
                                            />
                                        </Grid>
                                    ))}
                                </Grid>
                            </Box>
                        </>
                    )}
                    {activeTab === "imsReport" && (
                        <IMSReport
                            recordForTable={recordForTable}
                            loaderForTable={loaderForTable}
                            getApiImsReport={() => ims_outward_recon_id && getApiImsRepository(ims_outward_recon_id, 0, pagination.rowsPerPage)}
                            pagination={pagination}
                            handlePageChange={handlePageChange}
                            handleRowsPerPageChange={handleRowsPerPageChange}
                            handleStatus={handleStatus}
                            activeTab={activeTab}
                            errorLogId={errorLogId}
                            ims_recon_id={reconId}
                            tax_period={taxPeriod}
                        />

                    )}
                    {activeTab === "accepted" && (
                        <div style={{ display: "flex", justifyContent: "center", }}>
                            <IMSAccepted
                                recordForAcceptedTable={recordForAcceptedTable}
                                loaderForTable={loaderForTable}
                                // getApiImsAccepted={getApiImsAccepted}
                                getApiImsAccepted={() => ims_outward_recon_id && getApiImsAccepted(ims_outward_recon_id, 0, pagination.rowsPerPage)}
                                pagination={pagination}
                                handlePageChange={handlePageChange}
                                handleRowsPerPageChange={handleRowsPerPageChange}
                                activeTab={activeTab}

                            />
                        </div>
                    )}
                    {activeTab === "rejected" && (
                        <div style={{ display: "flex", justifyContent: "center", }}>
                            <IMSRejected
                                recordForRejectedTable={recordForRejectedTable}
                                loaderForTable={loaderForTable}
                                handleStatus={handleStatus}
                                getApiImsRejected={() => ims_outward_recon_id && getApiImsRejected(ims_outward_recon_id, 0, pagination.rowsPerPage)}
                                pagination={pagination}
                                handlePageChange={handlePageChange}
                                handleRowsPerPageChange={handleRowsPerPageChange}
                                activeTab={activeTab}
                            />
                        </div>
                    )}
                    {activeTab === "pending" && (
                        <div style={{ display: "flex", justifyContent: "center", }}>
                            <IMSPending
                                recordForPendingTable={recordForPendingTable}
                                loaderForTable={loaderForTable}
                                handleStatus={handleStatus}
                                reconId={reconId}
                                getApiImsPending={() => ims_outward_recon_id && getApiImsPending(ims_outward_recon_id, 0, pagination.rowsPerPage)}
                                pagination={pagination}
                                handlePageChange={handlePageChange}
                                handleRowsPerPageChange={handleRowsPerPageChange}
                                activeTab={activeTab}
                            />
                        </div>
                    )}
                    {activeTab === "noAction" && (
                        <div style={{ display: "flex", justifyContent: "center", }}>
                            <IMSNoAction
                                recordForNoActionTable={recordForNoActionTable}
                                loaderForTable={loaderForTable}
                                handleStatus={handleStatus}
                                ims_outward_recon_id={ims_outward_recon_id}
                                getApiImsNoAction={() => ims_outward_recon_id && getApiImsNoAction(ims_outward_recon_id, 0, pagination.rowsPerPage)}
                                pagination={pagination}
                                handlePageChange={handlePageChange}
                                handleRowsPerPageChange={handleRowsPerPageChange}
                                activeTab={activeTab}
                            />
                        </div>
                    )}
                </div>
            </div>
            {/* )} */}


        </div>
    );
}